import daterangepicker from '../daterangepicker';
import { CopyValueBtn } from "../components/CopyValueBtn";
import { SaveButton } from "../components/SaveButton";
import { HasAttachments } from "../CRUDs/abstracts/mixins/HasAttachments";
import { GalleryViewer } from '../components/GalleryViewer';
import SlidingVisibleElement from '../components/SlidingVisibleElement';
import RoundSlider from '../components/RoundSlider';
import BBRange from '../components/BBRange';
import { SimpleSectionSwitcher } from '../components/SimpleSectionSwitcher';

const isWtmPageDesignRoute = () => (
    location.pathname.includes('/admin/website-template-manager/page/')
    && location.pathname.includes('/design')
);

const isOrgWebsiteBuilderRoute = () => location.pathname.includes('/settings/website-builder');

const DEFAULT_PAGE_DESIGN_EDITOR_CONFIG = {
    isDesignRoute: () => isOrgWebsiteBuilderRoute() || isWtmPageDesignRoute(),
    pageBaseUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}`
            : `/settings/website-builder/${pageId}`
    ),
    getFormUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/get-form`
            : '/settings/website-builder/get-form'
    ),
    auxiliaryComponentUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/get-auxiliary-component`
            : `/settings/website-builder/${pageId}/get-auxiliary-component`
    ),
    showInGoogleUrl: (pageId) => `/settings/website-builder/${pageId}/show-in-google`,
    publishUrl: (pageId) => `/settings/website-builder/${pageId}/publish`,
    attachmentsUrlRoot: isWtmPageDesignRoute()
        ? '/admin/website-template-manager/page'
        : '/settings/website-builder',
    imageLibraryEnabled: () => (
        isWtmPageDesignRoute() || document.body.dataset.wtmOrgTemplateLibrary === '1'
    ),
    imageLibraryUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/image-library`
            : `/settings/website-builder/${pageId}/image-library`
    ),
    selectImageUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/select-image`
            : `/settings/website-builder/${pageId}/select-image`
    ),
    serviceTimeUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/get-service-time`
            : '/settings/website-builder/get-service-time'
    ),
    setGlobalSettingsUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/set-global-settings`
            : '/settings/website-builder/set-global-settings'
    ),
    resetGlobalSettingsUrl: (pageId) => (
        isWtmPageDesignRoute()
            ? `/admin/website-template-manager/page/${pageId}/reset-global-settings`
            : '/settings/website-builder/reset-global-settings'
    ),
    formDesignLinkSelector: '.form-design-page .wtm-open-form-design',
    useDeleteConfirmation: !isWtmPageDesignRoute(),
    backgroundUpdateRequest(form) {
        if (isWtmPageDesignRoute()) {
            const opacityInput = $(form).find('input[name="overlay_opacity"]');
            const opacityVal = opacityInput.length ? opacityInput.val() : 0;
            return {
                data: {
                    component_type: $(form).find('input[name="component_type"]').val(),
                    base_color: $(form).find('input[name="base_color"]').val(),
                    overlay_color: $(form).find('input[name="overlay_color"]').val(),
                    overlay_opacity: opacityVal !== undefined && opacityVal !== '' ? opacityVal : 0,
                },
            };
        }
        return {
            data: new FormData($(form)[0]),
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
        };
    },
    handleCreatedComponentResponse(response, blockId, modal) {
        if (response.view) {
            if (isWtmPageDesignRoute()) {
                $(`.block-${blockId}`).html(response.view);
                $(modal).modal('hide');
                return;
            }
            $(`.positioned-block[data-id="${blockId}"]`).replaceWith(response.view);
            $(modal).modal('hide');
            return;
        }
        location.reload(true);
    },
    handleCreatedBlockResponse(response, container, editor) {
        if (response.view) {
            $(container).find('.add-block-btn').click();
            if (isWtmPageDesignRoute()) {
                $(container).after(response.view);
                return;
            }
            const inserted = $(response.view).insertAfter(container);
            const block = inserted.filter('.positioned-block')[0];
            if (block instanceof HTMLElement) {
                editor.initPaddingRanges(block);
            }
            return;
        }
        location.reload(true);
    },
    embededFormScopeSelector: isWtmPageDesignRoute() ? '#template-demo-frame' : null,
    useGlobalDesignConfirmation: !isWtmPageDesignRoute(),
};

const createPageDesignEditor = (config = {}) => ({
    config: {
        ...DEFAULT_PAGE_DESIGN_EDITOR_CONFIG,
        ...config,
    },
    galleryViewers:[],
    aiRegenerationPollTimers: Object.create(null),
    aiAssetRegenerationPollTimers: Object.create(null),
    isInitialized: false,

    getPageId(){
        return $('#page_id').val();
    },

    pageBaseUrl(pageId = this.getPageId()){
        return this.config.pageBaseUrl(pageId);
    },

    getFormUrl(pageId = this.getPageId()){
        return this.config.getFormUrl(pageId);
    },

    ensureBuilderSidePanel(){
        const $panel = $('#form-container');
        if (!$panel.length) {
            return $panel;
        }
        $panel.addClass('builder-side-panel d-none');
        return $panel;
    },

    openBuilderSidePanel(html, options = {}){
        const $panel = this.ensureBuilderSidePanel();
        if (!$panel.length) {
            return $();
        }

        const shouldExpand = Boolean(options.expanded) || $panel.hasClass('is-expanded');
        $panel
            .removeClass('d-none')
            .addClass('is-open')
            .toggleClass('is-expanded', shouldExpand)
            .html(`
                <div class="builder-side-panel-content"></div>
            `);

        const $content = $panel.find('.builder-side-panel-content');
        $content.html(html);

        const $modal = $content.find('.modal').first();
        if ($modal.length) {
            $modal
                .addClass('builder-panel-modal show')
                .removeClass('fade')
                .attr('aria-modal', 'true')
                .removeAttr('aria-hidden')
                .css('display', 'block');
            $modal.find('.modal-dialog')
                .removeClass('modal-dialog-centered')
                .addClass('builder-panel-dialog');

            const $header = $modal.find('.modal-header').first();
            const sizeBtn = `
                <button type="button" class="builder-side-panel-size-btn" title="${shouldExpand ? 'Use compact panel' : 'Expand panel'}" aria-label="${shouldExpand ? 'Use compact panel' : 'Expand panel'}">
                    <span class="builder-side-panel-size-label">${shouldExpand ? 'Compact' : 'Expand'}</span>
                </button>
            `;
            if ($header.length) {
                const $actions = $('<div class="builder-side-panel-header-actions"></div>').html(sizeBtn);
                const $close = $header.find('.close_wrapper').first();
                if ($close.length) {
                    $actions.insertBefore($close);
                } else {
                    $header.append($actions);
                    $header.append('<button type="button" class="builder-side-panel-close-btn" title="Close panel" aria-label="Close panel">&times;</button>');
                }
            } else {
                $content.prepend(`
                    <div class="builder-side-panel-fallback-toolbar">
                        ${sizeBtn}
                        <button type="button" class="builder-side-panel-close-btn" title="Close panel" aria-label="Close panel">&times;</button>
                    </div>
                `);
            }
        }

        $('body').addClass('builder-side-panel-open');
        this.initBuilderSidePanelControls();
        this.prepareBuilderSidePanelLayout();
        this.initNavigationCategoryBuilder();
        if ($modal.length) {
            setTimeout(() => $modal.trigger('shown.bs.modal'), 0);
        }

        return $modal;
    },

    showInlineEditSelector(html, target, anchor = null){
        $('.select_block_part_modal').remove();
        const $selector = $(html).appendTo('body');
        $selector.css({
            display: 'block',
            position: 'fixed',
            visibility: 'hidden',
            zIndex: 1080,
        });

        const targetRect = target && typeof target.getBoundingClientRect === 'function'
            ? target.getBoundingClientRect()
            : null;
        const hasAnchor = anchor && Number.isFinite(anchor.clientX) && Number.isFinite(anchor.clientY);
        const hasRect = targetRect
            && targetRect.width > 0
            && targetRect.height > 0
            && targetRect.right > 0
            && targetRect.bottom > 0;
        const selectorWidth = $selector.outerWidth() || 220;
        const selectorHeight = $selector.outerHeight() || 120;
        const viewportWidth = $(window).width();
        const viewportHeight = $(window).height();
        const anchorRight = hasAnchor
            ? anchor.clientX + 12
            : (hasRect ? targetRect.right : 80 + selectorWidth);
        const anchorBottom = hasAnchor
            ? anchor.clientY + 18
            : (hasRect ? targetRect.bottom + 8 : 80);
        const anchorTop = hasAnchor
            ? anchor.clientY - 18
            : (hasRect ? targetRect.top - 8 : 80);
        const aboveTop = anchorTop - selectorHeight;
        const top = anchorBottom + selectorHeight > viewportHeight - 12 && aboveTop >= 12
            ? aboveTop
            : anchorBottom;
        const left = Math.min(anchorRight - selectorWidth, viewportWidth - selectorWidth - 12);

        $selector.css({
            top: `${Math.max(12, Math.min(top, viewportHeight - selectorHeight - 12))}px`,
            left: `${Math.max(12, left)}px`,
            visibility: 'visible',
        });
    },

    closeBuilderSidePanel(){
        const $panel = $('#form-container.builder-side-panel');
        $panel.removeClass('is-open').addClass('d-none').empty();
        $('body').removeClass('builder-side-panel-open');
    },

    initBuilderSidePanelControls(){
        $('body')
            .off('click.builderSidePanelClose')
            .on('click.builderSidePanelClose', '#form-container .builder-side-panel-close-btn, #form-container [data-dismiss="modal"]', (ev) => {
                ev.preventDefault();
                this.closeBuilderSidePanel();
            });

        $('body')
            .off('click.builderSidePanelSize')
            .on('click.builderSidePanelSize', '#form-container .builder-side-panel-size-btn', (ev) => {
                ev.preventDefault();
                const $panel = $('#form-container.builder-side-panel');
                $panel.toggleClass('is-expanded');
                const expanded = $panel.hasClass('is-expanded');
                $(ev.currentTarget)
                    .attr('title', expanded ? 'Use compact panel' : 'Expand panel')
                    .attr('aria-label', expanded ? 'Use compact panel' : 'Expand panel');
                $panel.find('.builder-side-panel-size-label').text(expanded ? 'Compact' : 'Expand');
                setTimeout(() => this.initRoundSliders(), 50);
            });
    },

    prepareBuilderSidePanelLayout(){
        const $panel = $('#form-container.builder-side-panel');
        if (!$panel.length) {
            return;
        }

        const saveSelector = [
            'button.save-form-btn',
            'button.edit-block-btn',
            'button.edit-component-btn',
            'button.edit-org-info-btn',
            'button.edit-background-image-btn',
            'button.create-component-btn',
            'button.create-content-block-btn',
            'button[data-save]',
            'button#wtm-save-form-design-btn',
        ].join(',');

        $panel.find(saveSelector).each(function() {
            const $button = $(this);
            const $row = $button.closest('.form-row, .modal-footer');
            if ($row.length) {
                $row.addClass('builder-side-panel-action-row');
            }
        });
    },

    showBuilderSidePanelStatus(success = true, message = ''){
        const $form = $('#form-container .component-settings-container, #form-container .block-settings-container, #form-container form').first();
        if (!$form.length) {
            return;
        }
        let $status = $form.find('.builder-side-panel-status').first();
        if (!$status.length) {
            $status = $('<div class="builder-side-panel-status mt-2 text-center"></div>');
            $form.append($status);
        }
        $status
            .removeClass('text-success text-danger d-none')
            .addClass(success ? 'text-success' : 'text-danger')
            .text(message || (success ? 'Saved' : 'Something went wrong'));
    },

    replaceEditorResponseFragments(response, blockId = null){
        if (!response) {
            return false;
        }

        if (response.target && response.view) {
            const $target = $(response.target);
            if ($target.length) {
                $target.replaceWith(response.view);
                this.mobileMenu();
                this.initAnchorBehavior();
                return true;
            }
        }

        if (response.views && typeof response.views === 'object') {
            Object.keys(response.views).forEach((id) => {
                const $current = $(`.positioned-block[data-id="${id}"]`);
                if ($current.length) {
                    $current.replaceWith(response.views[id]);
                    const inserted = $(`.positioned-block[data-id="${id}"]`)[0];
                    if (inserted) {
                        this.initPaddingRanges(inserted);
                    }
                }
            });
            return true;
        }

        if (response.view && blockId) {
            const $positioned = $(`.positioned-block[data-id="${blockId}"]`);
            if ($positioned.length) {
                $positioned.replaceWith(response.view);
                const inserted = $(`.positioned-block[data-id="${blockId}"]`)[0];
                if (inserted) {
                    this.initPaddingRanges(inserted);
                }
                return true;
            }
        }

        return false;
    },

    auxiliaryComponentUrl(pageId = this.getPageId()){
        return this.config.auxiliaryComponentUrl(pageId);
    },

    getEmbededFormScope(){
        return this.config.embededFormScopeSelector ? $(this.config.embededFormScopeSelector) : $(document.body);
    },

    init(){
        if (this.isInitialized) {
            return;
        }
        if (window.__BB_BUSINESS_PAGE_INITIALIZED__) {
            this.isInitialized = true;
            return;
        }
        this.isInitialized = true;
        window.__BB_BUSINESS_PAGE_INITIALIZED__ = true;

        if (this.config.isDesignRoute()) {
            this.saveActions();
            this.designActions();
            this.pagesActions();
            this.pagesValidation();
            this.createAndEditComponents();
            this.editForms();
            this.initAttachments();
            this.initTemplateImageLibraryPicker();
            //this.initColorPicker();
            this.updateFontWeidht();
            this.addNewBlockActions();
            this.modalActions();
            this.cssLivePreviewActions();
            this.editMediaBlock();
            this.copyValBtn = new CopyValueBtn('copyValue', 'copiedValue');
            this.editReviewActions();
            this.reactiveTextEditing();
            this.reactiveEditImage();
            try {
                this.initGlobalStyling();
                this.initPaddingRanges();
                this.initAiBlockRegenerationResume();
                this.initDesignerAssetRegenerationResume();
            } catch (error) {
                console.error(error);
            }
        }
        this.galleryView();
        this.initAnchorBehavior();
        this.activateReviewSlider();
        this.initResizeActions();
        this.loginModal();
        this.mobileMenu();
        this.checkPageSizeForFontSize();
        this.globalActions();
        this.embededFormActions();
        SlidingVisibleElement.init();
        var timeout =null;
    },
    pagesActions(){
        const editor = this;
        $('body').off('click','.delete-page-btn').on('click','.delete-page-btn',(e) => {
            const page_id = $(e.currentTarget).data('page_id');
            if (!this.config.useDeleteConfirmation) {
                $.ajax({
                    method: 'POST',
                    url: `${this.pageBaseUrl(page_id)}/delete`,
                    success: () => {
                        location.reload(true);
                    },
                    error: () => {},
                });
                return;
            }
            $.ajax({
                method: 'POST',
                url: `/jobs-flow/get-confirmation-modal`,
                data: {
                    entity: 'business_page',
                    id: page_id,
                },
                success: (response) => {
                    this.openBuilderSidePanel(response.view);
                    $('#confirm-action-modal').on('click', '.cancel-btn', function(e) {
                        e.preventDefault();
                        editor.closeBuilderSidePanel();
                    });
                },
                error: (response) => {},
            });
        });
        $('body').off('click', '.confirm-delete-page-btn').on('click', '.confirm-delete-page-btn', (e) => {
            const page_id = $(e.currentTarget).data('page_id');
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/delete`,
                success: (response) => {
                    location.reload(true);
                },
            });
        });
        $('body').off('click', '.switch-button')
        .on('click','.switch-button', function(e) {
            $(this).toggleClass('included is-on'); // .is-on drives the .bb-switch visual; .included stays the legacy state hook
            const entity = $(this).data('entity');
            const entity_id = $(this).data(`${entity}_id`);
            $.ajax({
                method: 'POST',
                url: editor.config.showInGoogleUrl(entity_id),
                success: (r)=>{

                },
                error: (r)=>{

                }
            });
        });
        $('body').off('click', '.publish-btn')
        .on('click','.publish-btn', function(e) {
            const entity_id = $(this).data(`page_id`);
            $.ajax({
                method: 'POST',
                url: editor.config.publishUrl(entity_id),
                success: (r)=>{
                    location.reload(true);
                },
                error: (response)=>{
                    if (response.responseJSON && response.responseJSON.billing_url) {
                        window.location.assign(response.responseJSON.billing_url);
                    }
                }
            });
        });

    },
    pagesValidation(){
        $('#create-business-page-form #friendly_url').on('keypress', function(event) {
            const inputValue = String.fromCharCode(event.which);
            if (!/[a-z0-9-_]/.test(inputValue)) {
                event.preventDefault(); // Отменяем ввод символа, если он не является числом или точкой
            }
        })
    },
    saveActions(){
        $('.create-business-page').click((e)=>{
            e.preventDefault();
            if (this.validation('.create-business-page-form')) {
                let form = $('#create-business-page-form')[0];
                let data = new FormData(form);
                let postfix = '';
                if ($(e.currentTarget).data('type') == 'preliminary') {
                    postfix = '/preliminary';
                }
                // console.log(data.get('service'));
                // return;
                $.ajax({
                    method: 'POST',
                    url: `/settings/website-builder/create${postfix}`,
                    data: data,
                    enctype: 'multipart/form-data',
                    processData: false,
                    contentType: false,
                    success: (response)=>{
                        console.log(response);
                        if ($(e.currentTarget).data('type') == 'preliminary') {
                            location.href = `/admin/preliminary-organisations/`;
                        } else {
                            location.href = '/settings/website-builder/';
                        }
                    },
                    error: (response) => {
                        // responseJSON is absent on 5xx HTML responses
                        this.showFlyError(response.responseJSON && response.responseJSON.errors);
                    }
                });
            }
        });
    },
    validation(form_name){
        let $is_valid=true;
        const form = $(form_name);
        form.find('input').css('border-color', '');
        if (form.find('#page_name').val() == '') {
            form.find('#page_name').css('border-color', 'red');
            $is_valid=false;
        }
        if (form.find('#friendly_name').val() == '') {
            $is_valid=false;
            form.find('#friendly_name').css('border-color', 'red');
        }
        if (form.find('#title').val() == '') {
            $is_valid=false;
            form.find('#title').css('border-color', 'red');
        }

        return $is_valid;
    },
    designActions(){
        $('body').off('click','.edit-design-elemnt-btn').on('click','.edit-design-elemnt-btn', (e) => {
            /* const editable_elem = $(e.currentTarget).parent().find('.editable-elem');
            const edit_input = $(e.currentTarget).parent().find('.edit-input');
            if ($(editable_elem).hasClass('d-none')) {
                $(editable_elem).removeClass('d-none');
                $(edit_input).addClass('d-none');
            } else {
                $(editable_elem).addClass('d-none');
                $(edit_input).removeClass('d-none');
            } */

            if ($(e.currentTarget).hasClass('icon')) {
                const componentType = $(e.currentTarget).data('component_type');
                if (componentType === 'header_image' || componentType === 'footer_image') {
                    this.showEditElementForm({
                        form_type: 'edit',
                        item_type: 'background_image',
                        component_type: componentType,
                    }, false, null, () => {
                        setTimeout(() => this.initModalRanges(), 200);
                    });
                    return;
                }
                const currentElem = $(e.currentTarget);
                HasAttachments.QueryData = {
                    component_id: $(e.currentTarget).data('component_id'),
                    component_type: $(e.currentTarget).data('component_type'),
                };
                HasAttachments.SuccessCallback = (r) => {
                    console.log("callback header", currentElem, currentElem.parent().find('section'), r.path);
                    if (currentElem.data('component_type') == 'header_image') {
                        currentElem.parent().find('section').css('background-image', `url(${r.path})`);
                    } else if(currentElem.data('component_type') == 'footer_image') {
                        $('.site-footer').find('style').text(
                            '.site-footer::before{'+
                                `background-image: url('${r.path}');`+
                            '}'
                        );

                        //$(e.currentTarget).parent().find('section').css('background-image', r.path);
                    }else{
                        location.reload(true);
                    }

                };
            }else if($(e.currentTarget).hasClass('block')){
                const data = {
                    form_type: 'edit',
                    block_id: $(e.currentTarget).data('block_id'),
                    item_type: $(e.currentTarget).data('item_type'),
                    content_type: $(e.currentTarget).data('content_type'),
                };
                this.showEditElementForm(data, false, null, this.initRangeInputListener());
            }else if ($(e.currentTarget).hasClass('block-parts')) {
                const selectorAnchor = {
                    clientX: e.clientX,
                    clientY: e.clientY,
                };
                const data = {
                    form_type: 'select_part',
                    block_id: $(e.currentTarget).data('block_id'),
                    item_type: $(e.currentTarget).data('item_type'),
                };
                $('.select_block_part_modal').remove();
                this.showEditElementForm(data, (response)=>{
                    this.showInlineEditSelector(response, e.currentTarget, selectorAnchor);
                }, e.currentTarget);
            }else {
                let callback = ()=> {};
                const data = {
                    form_type: 'edit',
                    item_type: $(e.currentTarget).data('item_type'),
                    item_id: $(e.currentTarget).data('content_id'),
                    content_type: $(e.currentTarget).data('content_type'),
                    content_part: $(e.currentTarget).data('content_part')
                };
                if ($(e.currentTarget).hasClass('social-links')) {
                    callback = (response) => {
                        this.initWebLinkValidator('#edit_social_links_modal', '.link-input');
                    }
                }
                this.showEditElementForm(data, false,null,callback);
            }
        })
        $('body').off('click.selectBlockPartClose').on('click.selectBlockPartClose','.select_block_part_modal .close-elem', () => {
            $('.select_block_part_modal').remove();
        })
        $('body').off('click', '.edit_block_text').on('click', '.edit_block_text', (e) => {
            $('.select_block_part_modal').remove();
            const data = {
                form_type: 'edit',
                block_id: $(e.currentTarget).data('block_id'),
                item_type: 'block',
            };
            this.showEditElementForm(data);
        });
        $('body').off('click', '.edit_block_button').on('click', '.edit_block_button', (e) => {
            $('.select_block_part_modal').remove();
            const data = {
                form_type: 'edit',
                item_id: $(e.currentTarget).data('component_id'),
                item_type: 'button',
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);
        });

        $('.edit-input').on('change', (e) => {
            const editing_type = $(e.currentTarget).data('editing-type');
            const editing_component = $(e.currentTarget).data('editing-component');
            const page_id = $('#page_id').val();
            const edited_value = $(e.currentTarget).val();
            let data = {
                editing_type:editing_type,
                editing_component:editing_component,
                edited_value:edited_value
            };
            if (editing_type == 'component') {
                data.component_id = $(e.currentTarget).data('component-id');
            }
            this.updateDesign(data, $(e.currentTarget).parent());
        });

        $('body').off('click','.add-component-btn').on('click','.add-component-btn', (e) => {
            const data = {
                form_type: 'add',
                item_type: 'component',
                block_id: $(e.currentTarget).data('block_id'),
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);
        });
        $('body').off('click','.add-other-btn').on('click','.add-other-btn', (e) => {
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('block_id')
            const data = {
                item_type: $(e.currentTarget).data('item_type'),
                block_id: block_id,
            };
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/component/create-default`,
                data: data,
                success: (response) => {
                    if(response?.view){
                        $(`.positioned-block[data-id="${block_id}"]`).find('.section-container').replaceWith(response.view)
                    }
                },
                error: (response) => { }
            });
        });
        $('.add-content-block-btn').click((e) => {
            const data = {
                form_type: 'add',
                item_type: 'content_block',
            };
            this.showEditElementForm(data);
        });
        $('.update-component-btn').click((e) => {
            const component_id = $(e.currentTarget).data('id');
            const data = {
                form_type: 'edit',
                item_type: 'component',
                item_id: component_id,
            };
            this.showEditElementForm(data);
        });
        $('body').off('click','.delete-component-btn').on('click','.delete-component-btn', (e) => {
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('block_id');
            // return;
            const elem = $(e.currentTarget);
            const component = $(e.currentTarget).parents('.component-image-container');
            $.ajax({
                method: "POST",
                url: `${this.pageBaseUrl(page_id)}/component/delete`,
                data: {
                    id: $(e.currentTarget).data('id'),
                },
                success: (response) => {
                    // console.log($(e.currentTarget).hasClass('image'), $(e.currentTarget));
                    if (elem.hasClass('image')) {
                        component.css('opacity', '0.4');
                        component.find('.close-menu').click();
                        component.addClass('lock-block');
                    }else if(response.view){
                        $(`.positioned-block[data-id="${block_id}"]`).replaceWith(response.view);
                    }else{
                        location.reload(true);
                    }
                },
                error: (response) => {

                }
            });
        });
        $('body').off('change', '#item_type, .item_type').on('change', '#item_type, .item_type', (e) => {
            const parent_row = $(e.currentTarget).parents('.form-row');
            const btns = $(e.currentTarget).parents('form').find('button').toArray();
            if ($(e.currentTarget).val() == 1) {
                parent_row.find('#related_page').parent().removeClass('d-none');
                parent_row.find('#related_link').parent().addClass('d-none');
                parent_row.find('#custom_link').parent().addClass('d-none');
                btns.forEach(element => {
                    if (element.classList.value.includes('edit')) {
                        let links = parent_row.parents('.modal').find('#custom_link:not(.d-none)').toArray();
                        $(element).removeAttr('disabled');
                        links.forEach(link => {
                            if (!$(link).parent().hasClass('d-none') && !this.linkValidation(link.value)) {
                                $(element).attr('disabled', true);
                            }
                        });
                    }
                });
            }else if($(e.currentTarget).val() == 2){
                parent_row.find('#related_page').parent().addClass('d-none');
                parent_row.find('#related_link').parent().removeClass('d-none');
                parent_row.find('#custom_link').parent().addClass('d-none');
                btns.forEach(element => {
                    if (element.classList.value.includes('edit')) {
                        let links = parent_row.parents('.modal').find('#custom_link:not(.d-none)').toArray();
                        $(element).removeAttr('disabled');
                        links.forEach(link => {
                            if (!$(link).parent().hasClass('d-none') && !this.linkValidation(link.value)) {
                                $(element).attr('disabled', true);
                            }
                        });
                    }
                });
            }else if($(e.currentTarget).val() == 3){
                parent_row.find('#related_page').parent().addClass('d-none');
                parent_row.find('#related_link').parent().addClass('d-none');
                parent_row.find('#custom_link').parent().removeClass('d-none');
                btns.forEach(element => {
                    if (element.classList.value.includes('edit') && !this.linkValidation(parent_row.find('#custom_link').val())) {
                        $(element).attr('disabled', true);
                    }
                });
            }else{
                parent_row.find('#related_page').parent().addClass('d-none');
                parent_row.find('#related_link').parent().addClass('d-none');
                parent_row.find('#custom_link').parent().addClass('d-none');
                btns.forEach(element => {
                    if (element.classList.value.includes('edit')) {                        
                        let links = parent_row.parents('.modal').find('#custom_link:not(.d-none)').toArray();
                        $(element).removeAttr('disabled');
                        
                        links.forEach(link => {
                            if (!$(link).parent().hasClass('d-none') && !this.linkValidation(link.value)) {
                                console.log(link.value, $(link).parent().hasClass('d-none'));
                                
                                $(element).attr('disabled', true);
                            }
                        });
                    }
                });
            }
        });
        $('body').off('input','#custom_link').on('input','#custom_link', (e)=>{
            const parent = $(e.currentTarget).parents('form');
            let btns = parent.find('button').toArray();
            if ($(e.currentTarget).val() !== '') {
                if (!this.linkValidation($(e.currentTarget).val())) {
                    $(e.currentTarget).attr('style','border-color: red !important');
                    btns.forEach(element => {
                        if (element.classList.value.includes('edit')) {
                            $(element).attr('disabled', true);
                        }
                    });
                }else{
                    $(e.currentTarget).css('border-color', '');
                    btns.forEach(element => {
                        if (element.classList.value.includes('edit')) {
                            $(element).removeAttr('disabled');
                        }
                    });
                }
            }
        })
        $('body').off('change', '#phone_number_type').on('change', '#phone_number_type', (e)=>{
            const value = $(e.currentTarget).val();
            const parent = $(e.currentTarget).parents('.form-row');
            if (value == 'static') {
                $(parent).find('#phone_number_value').val('');
                $(parent).find('#phone_number_value').removeAttr('disabled');
            } else {
                $(parent).find('#phone_number_value').val($(e.currentTarget).data('org_phone'));
                $(parent).find('#phone_number_value').attr('disabled', true);
            }
        });
        $('body').off('change', '#email_type').on('change', '#email_type', (e)=>{
            const value = $(e.currentTarget).val();
            const parent = $(e.currentTarget).parents('.form-row');
            if (value == 'static') {
                $(parent).find('#email_value').val('');
                $(parent).find('#email_value').removeAttr('disabled');
            } else {
                $(parent).find('#email_value').val($(e.currentTarget).data('org_email'));
                $(parent).find('#email_value').attr('disabled', true);
            }
        });
        $('body').off('change', '#address_type').on('change', '#address_type', (e)=>{
            const value = $(e.currentTarget).val();
            const parent = $(e.currentTarget).parents('.form-row');
            if (value == 'static') {
                $(parent).find('#address_value').val('');
                $(parent).find('#address_value').removeAttr('disabled');
            } else {
                $(parent).find('#address_value').val($(e.currentTarget).data('org_address'));
                $(parent).find('#address_value').attr('disabled', true);
            }
        });
        $('body').off('change', '#add-content-block-modal #content_type').on('change', '#add-content-block-modal #content_type', function() {
            if ($(this).val() == 4) {
                $('#add-content-block-modal #description').parent().removeClass('d-none');
            } else {
                $('#add-content-block-modal #description').parent().addClass('d-none');
            }
        })

        $('body').off('click','.hide-component-btn').on('click','.hide-component-btn', (e) => {
            const component_id = $(e.currentTarget).data('id');
            const block_id = $(e.currentTarget).data('block_id');
            const page_id = $('#page_id').val();
            const elem = $(e.currentTarget);

            $.ajax({
                method: "POST",
                url: `${this.pageBaseUrl(page_id)}/component/hide`,
                data: {
                    id: component_id,
                },
                success: (response) => {
                    if (response.view) {
                        if ($(`.block-${block_id}`).hasClass('site-footer__info') || $(`.block-${block_id}`).hasClass('titles')) {
                            let current_block = $(`.block-${block_id}`);
                            $(`.block-${block_id}`).after(response.view);
                            current_block.remove();
                        }else{
                            $(`.block-${block_id}`).html(response.view);
                        }
                    } else {
                        // onst container = elem.parents('.editable-continer');
                        // ontainer.find('.editable-elem').toggleClass('opacity-40');

                        location.reload(true);
                    }
                },
                error: (response) => {

                }
            });
        });

        $('body').off('click','.delete-block-confirm-btn').on('click','.delete-block-confirm-btn', (e)=>{
            const data = {
                form_type: 'delete',
                page_id: $('#page_id').val(),
                block_id: $(e.currentTarget).data('block_id'),
            };
            this.showEditElementForm(data);
        });

        $('body').off('click', '.regenerate-ai-block-open-btn').on('click', '.regenerate-ai-block-open-btn', (e) => {
            const data = {
                form_type: 'regenerate_block',
                page_id: $('#page_id').val(),
                block_id: $(e.currentTarget).data('block_id'),
                scope_default: $(e.currentTarget).data('scope-default'),
                lock_scope: $(e.currentTarget).data('lock-scope'),
                modal_title: $(e.currentTarget).data('modal-title'),
            };
            this.showEditElementForm(data);
        });

        $('body').off('click', '.open-regenerate-from-block-modal').on('click', '.open-regenerate-from-block-modal', (e) => {
            const button = $(e.currentTarget);
            const currentModal = button.closest('.modal');
            const data = {
                form_type: 'regenerate_block',
                page_id: $('#page_id').val(),
                block_id: button.data('block_id'),
                scope_default: button.data('scope-default'),
                lock_scope: button.data('lock-scope'),
                modal_title: button.data('modal-title'),
            };
            this.closeBuilderSidePanel();
            this.showEditElementForm(data);
        });

        $('body').off('click', '.regenerate-ai-block-btn').on('click', '.regenerate-ai-block-btn', (e) => {
            const page_id = $('#page_id').val();
            const button = $(e.currentTarget);
            const modal = button.closest('.modal');
            const backgroundComponentType = modal.find('#regenerate-ai-background-component-type').val();
            const sourceModalSelector = modal.find('#regenerate-ai-source-modal').val();
            const sourceModal = sourceModalSelector ? $(sourceModalSelector) : $();
            const blockId = modal.find('#regenerate-ai-block-id').val();
            const feedback = modal.find('#regenerate-ai-feedback').val();
            const originalText = button.text();

            button.prop('disabled', true).text('Starting…');

            if (backgroundComponentType) {
                button.text('Generating…');
                this.markBackgroundAiRegenerating(backgroundComponentType);

                const isLogoRegeneration = backgroundComponentType === 'nav_logo';
                const regenerateUrl = isLogoRegeneration
                    ? `${this.pageBaseUrl(page_id)}/regenerate-logo-ai`
                    : `${this.pageBaseUrl(page_id)}/regenerate-background-ai`;
                const csrfToken = $('meta[name="csrf-token"]').attr('content');
                const requestData = isLogoRegeneration
                    ? { _token: csrfToken, prompt: feedback }
                    : {
                        _token: csrfToken,
                        component_type: backgroundComponentType,
                        prompt: feedback,
                    };

                let assetRegenerationPollingStarted = false;

                $.ajax({
                    method: 'POST',
                    url: regenerateUrl,
                    data: requestData,
                    success: (response) => {
                        if (response?.queued) {
                            assetRegenerationPollingStarted = true;
                            this.closeBuilderSidePanel();
                            this.startDesignerAssetRegenerationPoll(page_id, backgroundComponentType, {
                                sourceModal,
                                sourceModalSelector: sourceModalSelector || '',
                                feedback,
                            });
                            button.prop('disabled', false).text(originalText);
                            return;
                        }

                        this.applyDesignerAssetRegenerationResult(backgroundComponentType, response, {
                            sourceModal,
                            feedback,
                        });
                        this.closeBuilderSidePanel();
                    },
                    error: (response) => {
                        const message = response?.responseJSON?.message
                            || response?.responseJSON?.errors?.prompt?.[0]
                            || 'Unable to regenerate this image right now.';
                        alert(message);
                    },
                    complete: () => {
                        if (!assetRegenerationPollingStarted) {
                            this.clearBackgroundAiRegenerationUi(backgroundComponentType);
                            button.prop('disabled', false).text(originalText);
                        }
                    }
                });
                return;
            }

            const scope = modal.find('input[name="regenerate_scope"]:checked').val()
                || modal.find('#regenerate-ai-fixed-scope').val()
                || 'whole';

            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/blocks/regenerate-ai`,
                data: {
                    block_id: blockId,
                    scope: scope,
                    feedback: feedback,
                },
                success: (response) => {
                    this.closeBuilderSidePanel();
                    if (response?.queued) {
                        this.markBlockAiRegenerating(blockId);
                        this.startAiRegenerationPoll(page_id, blockId);
                        return;
                    }
                    if (response?.view) {
                        $(`.positioned-block[data-id="${blockId}"]`).replaceWith(response.view);
                        const inserted = $(`.positioned-block[data-id="${blockId}"]`)[0];
                        if (inserted) {
                            this.initPaddingRanges(inserted);
                        }
                    }
                },
                error: (response) => {
                    const first = response?.responseJSON?.errors?.block_id?.[0];
                    const message = first || response?.responseJSON?.message || 'Unable to regenerate this block right now.';
                    alert(message);
                },
                complete: () => {
                    button.prop('disabled', false).text(originalText);
                }
            });
        });

        $('body').off('click','.delete-block-btn').on('click','.delete-block-btn', (e)=>{
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('id');
            $.ajax({
                method: "POST",
                url: `${this.pageBaseUrl(page_id)}/blocks/delete`,
                data: {
                    id: block_id,
                },
                success: (response) => {
                    $(`.positioned-block[data-id="${block_id}"]`).remove();
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });

        $('body').off('change', '#component_logo, #block-background-image, #block-background-inside-image')
        .on('change', '#component_logo, #block-background-image, #block-background-inside-image', function(e) {
            if (this.value !== '') {
                $(this).parent().find('label.file-label').text(this.files[0].name);
                const img = $(this).parents('.form-row').find('.image-preview-container').find('img');
                const file = this.files[0];
                const imgURL = URL.createObjectURL(file);
                if (img.length>0) {
                    img.attr('src', imgURL);
                } else {
                    $(e.currentTarget).parents('.form-row').find('.image-preview-container').html(`<img src="${imgURL}">`);
                }
                $(this).parent().find('#reset_logo').val('0');
            }
        });
        $('body').on('click', '.add-icon-btn', () => {
            const modalHtml = $('#add-icon-info-modal').prop('outerHTML');
            if (modalHtml) {
                this.openBuilderSidePanel(modalHtml);
            }
        });

        $('body').on('click','.position-manage-btn', (ev) => {
            if ($(this).hasClass('disabled')) {
                return;
            }

            let currentBlock = $($(ev.currentTarget).parents('.positioned-block')[0])
            const direction = $(ev.currentTarget).attr('data-sort-direction');
            const blockId =  currentBlock.attr('data-id');
            const sort = Number(currentBlock.attr('data-position'));
            let maxSort = sort
            let minSort = sort
            $('.positioned-block').each(function(){
                let rowSort = Number($(this).attr('data-position'))
                if(maxSort<rowSort)
                    maxSort = rowSort
                if(minSort>rowSort)
                    minSort = rowSort
            })
            let directElem = null
            if(direction == 'up' && sort != minSort && currentBlock.prev('.positioned-block')){
                directElem = currentBlock.prevAll('.positioned-block').first()
                directElem.before(currentBlock)
            }else if(direction == 'down' && sort != maxSort && currentBlock.next('.positioned-block')){
                directElem = currentBlock.nextAll('.positioned-block').first()
                directElem.after(currentBlock)
            }else{
                return
            }
            currentBlock.attr('data-position', directElem.attr('data-position'))
            directElem.attr('data-position', sort)
            currentBlock.addClass('move')
            setTimeout(()=>currentBlock.removeClass('move'), 300)

            $.ajax({
                method: 'POST',
                url: 'update-block-position',
                data: {
                    blockId,
                    directId: directElem.data('id'),
                },
                success: (response) =>{

                },
                error: (response)=>{

                }
            })
        });
        $('body').on('change','.colorpicker-element, .builder-colorpicker', (e)=>{
            const color = $(e.currentTarget).val();
            const parent = $(e.currentTarget).parents('.color-container');
            if (color) {
                $(parent).find('.color-preview').css('background-color', color);
            }
        });
    },
    linkValidation(link){
        let regex = /^http[s]?:\/\/.+\..+/;
        
        if (!regex.test(link)) {
            return false;
        }else{
            return true;
        }
    },
    initRangeInputListener(){
        let listRoundSliders = []
        setTimeout(() => {
            let sliderElems = document.getElementsByClassName('bb-range');
            listRoundSliders.push(new BBRange(sliderElems[0]))
        }, 300);
    },
    initWebLinkValidator(parent, field_name){
        $(parent).off(field_name).on('input',field_name, (e)=>{
            const parent = $(e.currentTarget).parents('form');
            let btns = parent.find('button').toArray();
            let regex = /^http[s]?:\/\/.+\..+/;
            if ($(e.currentTarget).val() !== '') {
                if (!regex.test($(e.currentTarget).val())) {
                    $(e.currentTarget).attr('style','border-color: red !important');
                    btns.forEach(element => {
                        if (element.classList.value.includes('edit')) {
                            $(element).attr('disabled', true);
                        }
                    });
                }else{
                    $(e.currentTarget).css('border-color', '');
                    btns.forEach(element => {
                        if (element.classList.value.includes('edit')) {
                            $(element).removeAttr('disabled');
                        }
                    });
                }
            }else{
                $(e.currentTarget).css('border-color', '');
                btns.forEach(element => {
                    if (element.classList.value.includes('edit')) {
                        $(element).removeAttr('disabled');
                    }
                });
            }
        })
    },
    showEditElementForm(data = {}, callback=false, target=null, successCallback = () => {}){
        data.page_id = $('#page_id').val();
        $.ajax({
            method: 'POST',
            url: this.getFormUrl(data.page_id),
            data: data,
            success: (response) => {
                if (callback !== false) {
                    callback(response, target);
                } else {
                    this.openBuilderSidePanel(response, { expanded: Boolean(data.expanded_panel) });
                    this.initColorPicker();
                    this.initDateRange();
                    this.initMasks();
                    this.initBackgroundSelector(data);
                    this.initNavigationCategoryBuilder();
                    setTimeout(()=>this.initRoundSliders(),200)
                    successCallback();
                }
            },
            error: (response) => {}
        });
    },

    updateDesign(data){
        const url = location.pathname+'/update';
        $.ajax({
            method: 'POST',
            url: url,
            data: data,
            success: (response) =>{
                location.reload(true);
            },
            error: (response) => {}
        });
    },
    initDateRange(){
        const picker = daterangepicker.setPicker($('#review_date'));
        $('#review_date').on('apply.daterangepicker', function(e, picker) {
            if ($(e.currentTarget).val() =='') {
                let date = new Date();
                $(e.currentTarget).val(date.toLocaleString('en-Us', {month:'long', day: 'numeric'}));
            }
            const date = $('#review_date').data('daterangepicker').startDate.format('Y-M-D');
            $('[name=review_date]').val(`${date}`);
        });
    },
    initMasks(){
        // Mask matches the format templates seed, e.g. "(425) 555-0188". The previous
        // 000-000-0000 mask could not represent the parentheses/space, so it wiped any
        // pre-filled value and left the field blank even though the page showed the
        // number. With (000) 000-0000 the stored value renders correctly and the mask
        // normalises any other format (digits or 425-555-0188) into the same shape.
        $('#phone_number_value')
            .mask('(000) 000-0000', {placeholder: '(___) ___-____'});
        $('#phone_number_value').off('paste').on('paste', function(e) {
            e.preventDefault();
            let pastedData = e.originalEvent.clipboardData.getData('Text');
            let digits = pastedData.replace(/\D/g, '');
            if (digits.length > 10) {
                digits = digits.slice(-10);
            }
            $(this).val(digits);
            $(this).trigger('input');
        });
    },

    initBackgroundSelector(data){
        if(data.item_type == 'block_background'){
            $('#block-background-color').colorpicker({format: 'hex'})
            $('#block-background-inside-color').colorpicker({format: 'hex'})
            $('#block-background-inside-active-color').colorpicker({format: 'hex'})
            $('#block-bg-color-in').colorpicker({format: 'hex'})
            $('#block-bcolor').colorpicker({format: 'hex'})
            $('#content-box-shadow-color').colorpicker({format: 'hex'})
            $('#background-type').off('change')
                .on('change', ev => {
                    if($('#background-type').val() == 'image'){
                        $('#image-input').removeClass('d-none')
                        $('#background-preview').removeClass('d-none')
                        $('#color-input').addClass('d-none')
                    }else{
                        $('#image-input').addClass('d-none')
                        $('#background-preview').addClass('d-none')
                        $('#color-input').removeClass('d-none')
                    }
                })
            $('#background-type-inside').off('change')
                .on('change', ev => {
                    if($('#background-type-inside').val() == 'image'){
                        $('#image-inside-input').removeClass('d-none')
                        $('#background-inside-preview').removeClass('d-none')
                        $('#color-inside-input').addClass('d-none')
                    }else{
                        $('#image-inside-input').addClass('d-none')
                        $('#background-inside-preview').addClass('d-none')
                        $('#color-inside-input').removeClass('d-none')
                    }
                })

            $('body').off('click.block-bg-eye').on('click.block-bg-eye', '.block-bg-eye-toggle', function() {
                var target = $(this).data('bg-target');
                var enabledInput = $('input.bg-enabled-input[data-bg-target="' + target + '"]');
                var bodyEl = $('.block-bg-body[data-bg-target="' + target + '"]');
                var isEnabled = enabledInput.val() === '1';
                if (isEnabled) {
                    enabledInput.val('0');
                    $(this).find('.show-elem').addClass('d-none');
                    $(this).find('.hide-elem').removeClass('d-none');
                    bodyEl.css({opacity: '0.4', 'pointer-events': 'none'});
                } else {
                    enabledInput.val('1');
                    $(this).find('.show-elem').removeClass('d-none');
                    $(this).find('.hide-elem').addClass('d-none');
                    bodyEl.css({opacity: '', 'pointer-events': ''});
                }
            });
        }
    },
    initNavigationCategoryBuilder(){
        const $manager = $('#form-container .nav-category-manager');
        if (!$manager.length) {
            return;
        }

        const slugify = (value) => String(value || 'category')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || 'category';

        const categoryCards = () => $manager.find('.nav-category-cards > .nav-category-card');
        const standaloneCard = () => $manager.find('[data-nav-standalone-card]').first();

        const categoryData = () => {
            standaloneCard().find('.nav-item-category-id').val('');

            return categoryCards().map((index, card) => {
                const $card = $(card);
                const label = ($card.find('.nav-category-label').val() || '').trim() || `Category ${index + 1}`;
                let id = ($card.find('.nav-category-id').val() || '').trim();
                if (!id) {
                    id = `nav-cat-${slugify(label)}-${index + 1}`;
                    $card.find('.nav-category-id').val(id);
                }
                $card.find('input[name$="[position]"]').val(index + 1);
                $card.find('.nav-category-card-title').text(label);
                $card.find('.nav-item-category-id').val(id);
                return { id, label };
            }).get();
        };

        const refreshCategoryState = () => categoryData();

        const refreshTargets = ($row) => {
            const type = String($row.find('.nav-item-type').val() || '1');
            $row.find('.nav-target').addClass('d-none');
            if (type === '1') {
                $row.find('.nav-target-page').removeClass('d-none');
            } else if (type === '2') {
                $row.find('.nav-target-section').removeClass('d-none');
            } else if (type === '3') {
                $row.find('.nav-target-url').removeClass('d-none');
            }
        };

        const pageOptions = () => $manager.find('.nav-page-options-template').html() || '';
        const sectionOptions = () => $manager.find('.nav-section-options-template').html() || '';
        const navItemMarkup = (index, categoryId, label = 'New Link') => `
            <div class="nav-item-row" data-item-index="${index}">
                <input type="hidden" name="nav_items[${index}][id]" value="">
                <input type="hidden" name="nav_items[${index}][is_hided]" value="0">
                <input type="hidden" name="nav_items[${index}][category_id]" class="nav-item-category-id" value="${categoryId}">
                <div class="nav-item-row-header">
                    <label>Link Label</label>
                    <button type="button" class="btn btn-outline-danger btn-sm remove-nav-item-btn">Remove</button>
                </div>
                <input name="nav_items[${index}][label]" class="form-control" maxlength="80" value="${label}">
                <div class="nav-item-controls">
                    <div>
                        <label>Action Type</label>
                        <select name="nav_items[${index}][item_type]" class="form-control nav-item-type">
                            <option value="1" selected>Go to Page</option>
                            <option value="2">Scroll to Section</option>
                            <option value="3">Open External Link</option>
                        </select>
                    </div>
                    <div class="nav-target nav-target-page">
                        <label>Select Page</label>
                        <select name="nav_items[${index}][relation_page_id]" class="form-control">${pageOptions()}</select>
                    </div>
                    <div class="nav-target nav-target-section d-none">
                        <label>Select Section</label>
                        <select name="nav_items[${index}][related_link]" class="form-control">${sectionOptions()}</select>
                    </div>
                    <div class="nav-target nav-target-url d-none">
                        <label>URL</label>
                        <input name="nav_items[${index}][related_url]" class="form-control" value="" placeholder="https://example.com">
                    </div>
                </div>
            </div>
        `;

        $('body')
            .off('click.navCategoryBuilderAddCategory')
            .on('click.navCategoryBuilderAddCategory', '#form-container .add-nav-category-btn', (event) => {
                event.preventDefault();
                const maxCategories = Number($manager.data('max-categories') || 5);
                if (categoryCards().length >= maxCategories) {
                    this.showBuilderSidePanelStatus(false, `Navigation can have up to ${maxCategories} categories.`);
                    return;
                }
                const index = Number($manager.data('next-category-index') || 0);
                $manager.data('next-category-index', index + 1);
                const id = `nav-cat-category-${Date.now()}-${index}`;
                $manager.find('.nav-category-cards').append(`
                    <div class="nav-category-card" data-category-index="${index}">
                        <input type="hidden" name="nav_categories[${index}][id]" class="nav-category-id" value="${id}">
                        <input type="hidden" name="nav_categories[${index}][position]" value="${index + 1}">
                        <div class="nav-category-card-header">
                            <div>
                                <div class="nav-category-card-title">Category ${index + 1}</div>
                                <label>Top-Level Menu Button</label>
                            </div>
                            <button type="button" class="btn btn-outline-danger btn-sm remove-nav-category-btn">Remove</button>
                        </div>
                        <input name="nav_categories[${index}][label]" class="form-control nav-category-label" maxlength="60" value="Category ${index + 1}">
                        <div class="nav-category-links"></div>
                        <div class="mt-2">
                            <button type="button" class="btn btn-outline-primary btn-sm add-nav-item-btn">+ Link</button>
                        </div>
                    </div>
                `);
                refreshCategoryState();
            });

        $('body')
            .off('click.navCategoryBuilderRemoveCategory')
            .on('click.navCategoryBuilderRemoveCategory', '#form-container .remove-nav-category-btn', (event) => {
                event.preventDefault();
                $(event.currentTarget).closest('.nav-category-card').remove();
                refreshCategoryState();
            });

        $('body')
            .off('click.navCategoryBuilderAddItem')
            .on('click.navCategoryBuilderAddItem', '#form-container .add-nav-item-btn', (event) => {
                event.preventDefault();
                const $button = $(event.currentTarget);
                refreshCategoryState();
                const index = Number($manager.data('next-item-index') || 0);
                $manager.data('next-item-index', index + 1);

                if ($button.hasClass('add-nav-standalone-item-btn')) {
                    const $row = $(navItemMarkup(index, ''));
                    $row.find('.nav-item-category-id').val('');
                    $manager.find('.nav-standalone-links').append($row);
                    refreshTargets($row);
                    return;
                }

                const $card = $button.closest('.nav-category-card');
                const categoryId = String($card.find('.nav-category-id').val() || '').trim();
                if (!categoryId) {
                    this.showBuilderSidePanelStatus(false, 'Add a category first.');
                    return;
                }
                const $row = $(navItemMarkup(index, categoryId));
                $card.find('.nav-category-links').append($row);
                refreshTargets($row);
            });

        $('body')
            .off('click.navCategoryBuilderRemoveItem')
            .on('click.navCategoryBuilderRemoveItem', '#form-container .remove-nav-item-btn', (event) => {
                event.preventDefault();
                $(event.currentTarget).closest('.nav-item-row').remove();
            });

        $('body')
            .off('input.navCategoryBuilderCategoryLabel')
            .on('input.navCategoryBuilderCategoryLabel', '#form-container .nav-category-label', () => {
                refreshCategoryState();
            });

        $('body')
            .off('change.navCategoryBuilderItemType')
            .on('change.navCategoryBuilderItemType', '#form-container .nav-item-type', (event) => {
                refreshTargets($(event.currentTarget).closest('.nav-item-row'));
            });

        refreshCategoryState();
        $manager.find('.nav-item-row').each((_, row) => refreshTargets($(row)));
    },
    createAndEditComponents(){

        $('body').off('.create-component-btn').on('click', '.create-component-btn', (e) => {
            const form = $(e.currentTarget).parents('form');
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('block_id');
            const modal = $(e.currentTarget).parents('.modal');
            let data = new FormData($(form)[0]);
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/component/create`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    if (this.replaceEditorResponseFragments(response, block_id)) {
                        this.showBuilderSidePanelStatus(true, 'Saved');
                        return;
                    }
                    this.config.handleCreatedComponentResponse(response, block_id, modal);
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
        $('body').off('.edit-component-btn').on('click', '.edit-component-btn', (e) => {
            const form = $(e.currentTarget).parents('form');
            const block_id = $(e.currentTarget).data('block_id');
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);
            const parent = $(e.currentTarget).parents('.modal').attr('id');
            console.log(parent + ' .component-settings-container');

            const saveBtn = new SaveButton('#' + parent + ' .component-settings-container');
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/component/update`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                beforeSend: () => {
                    saveBtn.startLoading();
                },
                success: (response)=>{
                    if (this.replaceEditorResponseFragments(response, block_id)) {
                        this.showBuilderSidePanelStatus(true, 'Saved');
                    } else {
                        location.reload(true);
                    }
                    saveBtn.stopLoading(false,'Save');
                },
                error: (response) => {
                    console.log(response);
                    this.showBuilderSidePanelStatus(false);
                    saveBtn.stopLoading(false,'Save');
                }
            });
        });
        $('body').off('.create-content-block-btn').on('click', '.create-content-block-btn', (e)=>{
            e.preventDefault();
            const form = $(e.currentTarget).parents('form');
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);

            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/component/create`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    location.reload(true);
                },
                error: (response) => {
                    console.log(response);
                }
            });

        });

        $('body').off('.edit-block-btn').on('click','.edit-block-btn', (e)=> {
            const form = $(e.currentTarget).parents('form');
            const modal = $(e.currentTarget).parents('.modal');
            const block_id = $(e.currentTarget).data('block_id');
            /* if (form.length == 0) {
                location.reload(true);
            } */
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);
            console.log(data.get('id'));
            console.log(block_id)
            if (form.length == 0 || !data.get('id')) {
                data.append('id', block_id);
            }
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/blocks/update`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    if (response.need_reload === true) {
                        window.location.reload(true);
                        return;
                    }
                    if (this.replaceEditorResponseFragments(response, block_id)) {
                        this.showBuilderSidePanelStatus(true, 'Saved');
                        return;
                    }
                    if (response.view) {
                        if($(`.block-${block_id}`).parents('.editable-header-block').length){
                            let textAlign = data.get('component_text_align') ?? 0;
                            let headerCont = $($(`.block-${block_id}`).parents('.editable-header-block')[0].parentElement)
                            headerCont.removeClass('justify-content-start justify-content-center justify-content-end')
                                        .addClass(textAlign == 1 ? 'justify-content-center' : (textAlign == 2 ? 'justify-content-end' : ''))
                            let header = $($(`.block-${block_id}`).parents('.editable-header-block')[0])
                            header.removeClass('align-items-center align-items-start align-items-end')
                                .addClass(textAlign == 1 ? 'align-items-center' : (textAlign == 2 ? 'align-items-end' : ''))
                            let parentCont = $($(`.block-${block_id}`).parents('.page-container')[0])
                            if(parentCont.find('.embeded-form').length){
                                parentCont.removeClass('align-items-start align-items-center align-items-end')
                                    .addClass(textAlign == 1 ? 'align-items-center' : (textAlign == 2 ? 'align-items-end' : ''))
                            }
                        }if ($(`.block-${block_id}`).hasClass('site-footer__info')) {
                            if (response.view.includes('site-footer__info-details')) {
                                $(`.block-${block_id}`).find('.site-footer__info-details').remove();
                                $(`.block-${block_id}`).append(response.view);
                            } else if(response.view.includes('site-footer__info-branding')) {
                                $(`.block-${block_id}`).find('.site-footer__info-branding').remove();
                                $(`.block-${block_id}`).prepend(response.view);
                            }
                        }else if($(`.block-${block_id}`).parents('.titles').length){
                            $(`.block-${block_id}`).html(response.view);
                        } else {
                            $(`.positioned-block[data-id="${block_id}"]`).replaceWith(response.view);
                        }
                        this.showBuilderSidePanelStatus(true, 'Saved');
                    }else{
                        location.reload(true);
                    }
                    let bgEnabled = data.get('background-color-enabled') !== '0';
                    let bgType = data.get('background-type')
                    const block = $(`.page-section.block-${block_id}`)[0]
                    if (!bgEnabled) {
                        if (block) { block.style.backgroundColor = ''; block.style.backgroundImage = ''; }
                    } else if(bgType == 'color'){
                        let color = data.get('background-color')
                        if (block) { block.style.backgroundColor = color; block.style.backgroundImage = ''; }
                    }else if(bgType == 'image'){
                        let image = data.get('background-image')
                        if(image?.size > 0 && block){
                            const imageUrl = URL.createObjectURL(image);
                            block.style.backgroundImage = `url(${imageUrl})`;
                            block.style.backgroundSize = 'cover';
                            block.style.backgroundPosition = 'center';
                            block.style.backgroundRepeat = 'no-repeat';
                        }
                    }
                },
                error: (response) => {
                    console.log(response);
                    this.showBuilderSidePanelStatus(false);
                }
            });
        });
        $('body').off('click','.edit-org-info-btn').on('click', '.edit-org-info-btn', (e) => {
            const parentForm = $(e.currentTarget).parents('form');
            let data = {};
            if ($(e.currentTarget).hasClass('links')) {
                data = {
                    links: {}
                }
                const LinksArray = parentForm.find('.link-row').toArray();
                let resArr = [];
                let relation = '';

                LinksArray.forEach((element, index) => {
                    if ($(element).find(`[name="link${index+1}_item_type"]`).val() == 1) {
                        relation = $(element).find(`[name="link${index+1}_relation_page_id"]`).val();
                    } else if($(element).find(`[name="link${index+1}_item_type"]`).val() == 2) {
                        relation = $(element).find(`[name="link${index+1}_related_block"]`).val();
                    } else if($(element).find(`[name="link${index+1}_item_type"]`).val() == 3) {
                        relation = $(element).find(`[name="link${index+1}_related_link"]`).val();
                    }
                    resArr.push({
                        title: $(element).find(`[name="link${index+1}_title"]`).val(),
                        type_relation: $(element).find(`[name="link${index+1}_item_type"]`).val(),
                        relation_page_id: relation,
                    })
                });
                data.links = resArr;
                data.editing_type = $(e.currentTarget).data('editing-component');
            } else if($(e.currentTarget).hasClass('social-links')){
                data = {
                    social_links: {
                       twitter: $('#twitter').val(),
                       facebook: $('#facebook').val(),
                       instagram: $('#instagram').val(),
                       linkedin: $('#linkedin').val(),
                    }
                };
                data.editing_type = $(e.currentTarget).data('editing-component');

            } else {
                data = {
                    info:{
                        phone_number: {
                            type: $(parentForm).find('#phone_number_type').val(),
                            custom_value: $(parentForm).find('#phone_number_value').val(),
                        },
                        email: {
                            type: $(parentForm).find('#email_type').val(),
                            custom_value: $(parentForm).find('#email_value').val(),
                        },
                        address: {
                            type: $(parentForm).find('#address_type').val(),
                            custom_value: $(parentForm).find('#address_value').val(),
                        },
                        design: {
                            font_family: $(parentForm).find('.component_font_family').val(),
                            text_color: $(parentForm).find('#text_color').val(),
                            font_size: $(parentForm).find('.component-font-size').val(),
                            font_weight: $(parentForm).find('.component-font-weight').val(),
                        }
                    },
                    editing_type: $(e.currentTarget).data('editing-component')
                };
            }
            this.updateDesign(data);
        });
        $('body').off('click', '.add_link_btn').on('click', '.add_link_btn', (e)=>{
            const page_id = $('#page_id').val();
            const target = $(e.currentTarget);
            console.log(target);

            $.ajax({
                method: 'POST',
                url: this.auxiliaryComponentUrl(page_id),
                data: {
                    type:"link-row",
                    iteration: $(e.currentTarget).parents('form').find('.link-row').length + 1,
                },
                success: (r) => {
                    target.parents('form').find('.links-container').append(r);
                }
            });
        });
        $('body').on('click', '.delete-row', (e)=>{
            $(e.currentTarget).parents('.link-row').addClass('explode');
            const parent = $(e.currentTarget).parents('.link-row');
            setTimeout(() => {
                parent.remove();
            }, 700);
        })
    },

    editForms(){
        $('body').off('change', '#edit-form-modal #form_type, .form-tab #form_type')
        .on('change', '#edit-form-modal #form_type, .form-tab #form_type', (e) => {
            const parent_form = $(e.currentTarget).parents('form');
                parent_form.find('#form-orientation').find('option[value="4"], option[value="3"]').removeAttr('disabled');
            if ($(e.currentTarget).val() == 'service-request') {
                parent_form.find('#form_service').parent().removeClass('d-none');
                parent_form.find('#form-orientation').parent().removeClass('d-none');
                if (parent_form.find('#form-orientation').val() == 3) {
                    parent_form.find('.button-styles').removeClass('d-none');
                }
            }else if($(e.currentTarget).val() == 'job-request'){
                parent_form.find('#form-orientation').parent().removeClass('d-none');
                parent_form.find('#form_service').parent().addClass('d-none');
                if (parent_form.find('#form-orientation').val() == 3) {
                    parent_form.find('.button-styles').removeClass('d-none');
                }
            }else if($(e.currentTarget).val() == 'simple-request'){
                parent_form.find('#form-orientation').parent().removeClass('d-none');
                parent_form.find('#form-orientation').find('option[value="4"], option[value="3"]').attr('disabled', true);
                parent_form.find('#form-orientation').val(1);
                parent_form.find('#form_service').parent().addClass('d-none');
                parent_form.find('.button-styles').addClass('d-none');
            }else if($(e.currentTarget).val() == 'chat'){
                // Footer "Contact form": inline vertical snippet, no button styles.
                parent_form.find('#form_service').parent().addClass('d-none');
                parent_form.find('#form-orientation').parent().addClass('d-none');
                parent_form.find('.button-styles').addClass('d-none');
            }else if($(e.currentTarget).val() == 'button'){
                // Footer "Button": CTA button (orientation 3) — show button styles only here.
                parent_form.find('#form_service').parent().addClass('d-none');
                parent_form.find('#form-orientation').parent().addClass('d-none');
                parent_form.find('.button-styles').removeClass('d-none');
                if (parent_form.find('#button_text').val() == '') {
                    parent_form.find('#button_text').val('Get Free Estimate');
                }
            }else if($(e.currentTarget).val() == 'button'){
                parent_form.find('.button-styles').removeClass('d-none');
            }else{
                parent_form.find('#form_service').parent().addClass('d-none');
                parent_form.find('#form-orientation').parent().addClass('d-none');
                parent_form.find('.button-styles').addClass('d-none');
            }
            this.showFormDesignLink(parent_form, parent_form.find('#form-orientation').val());
        });
        $('body').off('change', '#edit-form-modal #form-orientation, .form-tab #form-orientation').on('change', '#edit-form-modal #form-orientation, .form-tab #form-orientation', (e)=>{
            const parent_form = $(e.currentTarget).parents('form');
            if ($(e.currentTarget).val() == 3) {
                parent_form.find('.button-styles').removeClass('d-none');
                if (parent_form.find('#button_text').val() == '') {
                    if (parent_form.find('#form_type').val() == 'service-request') {
                        parent_form.find('#button_text').val('Schedule an Appointmnet');
                    }else if(parent_form.find('#form_type').val() == 'job-request'){
                        parent_form.find('#button_text').val('Request and Estimate');
                    }else if(parent_form.find('#form_type').val() == 'chat'){
                        parent_form.find('#button_text').val('Send us a Message');
                    }
                }
            }else{
                parent_form.find('.button-styles').addClass('d-none');
            }
            this.showFormDesignLink(parent_form, $(e.currentTarget).val());
        })
        $('body').off('click', '#edit-form-modal .save-form-btn').on('click','#edit-form-modal .save-form-btn', (e) => {
            const editing_component = $(e.currentTarget).data('editing-component');
            const $f = $('#edit-form-modal form');
            const formTypeVal = $f.find('#form_type').val();
            // Footer folds the "Button" CTA into the Form list: value "button" maps to
            // form_type=hide + orientation=3 (the page renders the button purely off orientation 3).
            let savedFormType = formTypeVal;
            let orientRaw;
            if (editing_component === 'footer_form') {
                if (formTypeVal === 'button') {
                    savedFormType = 'hide';
                    orientRaw = '3';
                } else {
                    orientRaw = '1';
                }
            } else {
                orientRaw = formTypeVal == 'hide' ? '1' : $f.find('#form-orientation').val();
            }
            const orient = parseInt(String(orientRaw), 10) || 1;
            let hero_conversion_type = '';
            if (editing_component === 'header_form') {
                if (orient === 4) {
                    hero_conversion_type = 'horizontal_embedded';
                } else if (orient === 3) {
                    hero_conversion_type = 'button_only';
                } else if (orient === 2) {
                    hero_conversion_type = 'horizontal_strip';
                } else if (orient === 1 || orient === 0) {
                    hero_conversion_type = 'vertical';
                }
            }
            // Preserve the footer CTA link target (replaced wholesale on save).
            const footerButtonAction = $f.find('#footer_button_action').val();
            const footerTargetSection = $f.find('#footer_target_section_id').val();
            const edited_value = JSON.stringify({
                form_type: savedFormType,
                form_service: $f.find('#form_service').val(),
                form_orientation: orientRaw,
                ...(hero_conversion_type !== '' ? { hero_conversion_type: hero_conversion_type } : {}),
                ...(footerButtonAction ? { button_action: footerButtonAction } : {}),
                ...(footerTargetSection ? { target_section_id: footerTargetSection } : {}),
                button_text: $f.find('#button_text').val(),
                color: $f.find('#text_color').val(),
                font_family: $f.find('.component_font_family').val(),
                font_size: $f.find('.component-font-size').val(),
                background: $f.find('.component-background').val(),
                font_weight: $f.find('.component-font-weight').val(),
                border_color: $f.find('#button_border_color').val(),
                border_radius: $f.find('#button_border_radius').val(),
                height: $f.find('#button_height').val(),
                border_width: $f.find('#button_border_width').val()
            });
            let data = {
                editing_type: 'form',
                editing_component:editing_component,
                edited_value:edited_value,
            };

            this.updateDesign(data);
        });
        $('body').off('click', '.reset-logo-btn').on('click', '.reset-logo-btn', (e) => {
            const parent_form = $(e.currentTarget).parents('form');
            parent_form.find('#component_logo').val('');
            parent_form.find('label[for="component_logo"]').text('Select file');
            parent_form.find('.preview-image').attr('src', $(e.currentTarget).data('logo_path'));
            parent_form.find('#reset_logo').val('1');
        });
    },

    showFormDesignLink(parent, form_orientation){
        const form_type = $('#form_type').val();
        const type_name = form_type == 'service-request' ? 'order' : (form_type == 'job-request' ? 'request' : (form_type == 'simple-request' ? 'simple-request' : false));
        parent.find(this.config.formDesignLinkSelector).addClass('d-none');
        if (type_name) {
            if (form_orientation == 4) {
                parent.find(`${this.config.formDesignLinkSelector}.${type_name}.embeded`).removeClass('d-none');
            } else {
                parent.find(`${this.config.formDesignLinkSelector}.${type_name}:not(.embeded)`).removeClass('d-none');
            }
        }
    },

    initAttachments(){
        if (this.config.isDesignRoute()) {
            HasAttachments.id = $('#page_id').val();
            HasAttachments.urlRoot = this.config.attachmentsUrlRoot;
            HasAttachments.isHightQuality = true;
            HasAttachments.scopeOpenDropZoneListener({}, ()=>{});
        }
    },

    initTemplateImageLibraryPicker(){
        if (!this.config.imageLibraryEnabled || !this.config.imageLibraryEnabled()) {
            return;
        }

        const editor = this;
        $('body').off('shown.bs.modal.templateImageLibrary', '#dropzone-modal, #edit-background-image-modal')
            .on('shown.bs.modal.templateImageLibrary', '#dropzone-modal, #edit-background-image-modal', function () {
                const $modal = $(this);
                if ($modal.is('#edit-background-image-modal')) {
                    editor.setupBackgroundImageLibraryContext($modal);
                }
                editor.loadTemplateImageLibrary($modal);
            });

        $('body').off('click.templateImageLibraryPreview', '.bb-template-image-library-preview-back')
            .on('click.templateImageLibraryPreview', '.bb-template-image-library-preview-back', function () {
                editor.resetTemplateImageLibraryView($(this).closest('.modal'));
            });

        $('body').off('click.templateImageLibraryApply', '.bb-template-image-library-preview-apply')
            .on('click.templateImageLibraryApply', '.bb-template-image-library-preview-apply', function () {
                const url = $(this).data('url');
                if (url) {
                    editor.selectTemplateLibraryImage(url, $(this).closest('.modal'));
                }
            });
    },

    setupBackgroundImageLibraryContext($modal){
        const componentType = $modal.find('input[name="component_type"]').val();
        HasAttachments.QueryData = { component_type: componentType };
        HasAttachments.SuccessCallback = (response) => {
            this.applyBackgroundImageSelectionResponse($modal, response, componentType);
        };
    },

    applyBackgroundImageSelectionResponse($modal, response, componentType){
        if (response?.view) {
            const $previewShell = $modal.find('.background-image-preview-shell');
            if ($previewShell.length) {
                $previewShell.html(response.view);
            } else {
                $modal.find('.block-images-components').html(response.view);
            }
        }
        if (response?.path) {
            if (componentType === 'header_image') {
                $('.edit-design-elemnt-btn.icon.header-image').parent().find('section.major-banner').first()
                    .css('background-image', `url(${response.path})`);
            } else if (componentType === 'footer_image') {
                $('.site-footer').find('style').text(
                    '.site-footer::before{background-image: url(\'' + response.path + '\');}'
                );
            }
        }
    },

    applyDesignerBackgroundStyles(componentType, backgroundStyles){
        const $target = componentType === 'footer_image'
            ? $('.site-footer').first()
            : $('.edit-design-elemnt-btn.icon.header-image').parent().find('section.major-banner').first();
        if (!$target.length || !backgroundStyles) {
            return false;
        }
        if (typeof backgroundStyles === 'string') {
            const scratch = document.createElement('div');
            scratch.style.cssText = backgroundStyles;
            for (let i = 0; i < scratch.style.length; i += 1) {
                const property = scratch.style[i];
                $target[0].style.setProperty(
                    property,
                    scratch.style.getPropertyValue(property),
                    scratch.style.getPropertyPriority(property)
                );
            }
            return true;
        }
        $target.css(backgroundStyles);
        return true;
    },

    getTemplateImageLibraryRoot($modal){
        return $modal.find('[data-wtm-template-image-library]').first();
    },

    showTemplateImageLibraryPreview($modal, url, label){
        const $library = this.getTemplateImageLibraryRoot($modal);
        $library.find('.bb-template-image-library-picker').addClass('d-none');
        $library.find('.bb-template-image-library-preview').removeClass('d-none');
        $library.find('.bb-template-image-library-preview-image').attr('src', url).attr('alt', label);
        $library.find('.bb-template-image-library-preview-label').text(label);
        $library.find('.bb-template-image-library-preview-apply')
            .data('url', url)
            .prop('disabled', false)
            .text('Apply');
        $library.find('.bb-template-image-library-error').addClass('d-none').text('');
    },

    resetTemplateImageLibraryView($modal){
        const $library = this.getTemplateImageLibraryRoot($modal);
        if (!$library.length) {
            return;
        }
        $library.find('.bb-template-image-library-preview').addClass('d-none');
        $library.find('.bb-template-image-library-picker').removeClass('d-none');
        $library.find('.bb-template-image-library-preview-image').attr('src', '').attr('alt', '');
        $library.find('.bb-template-image-library-preview-label').text('');
        $library.find('.bb-template-image-library-preview-apply').removeData('url');
        $library.find('.bb-template-image-library-error').addClass('d-none').text('');
    },

    loadTemplateImageLibrary($modal){
        const pageId = $('#page_id').val();
        const $library = this.getTemplateImageLibraryRoot($modal);
        const $grid = $library.find('.bb-template-image-library-grid');
        const $meta = $library.find('.bb-template-image-library-meta');

        if (!$library.length || !pageId) {
            return;
        }

        this.resetTemplateImageLibraryView($modal);
        $library.removeClass('d-none');
        $grid.html('<div class="small text-muted">Loading template images...</div>');
        $meta.text('');

        $.ajax({
            method: 'GET',
            url: this.config.imageLibraryUrl(pageId),
            success: (response) => {
                const items = Array.isArray(response?.items) ? response.items : [];
                if (!items.length) {
                    $library.addClass('d-none');
                    return;
                }

                $meta.text(`${items.length} image${items.length === 1 ? '' : 's'} from this template kit`);
                $grid.empty();
                items.forEach((item) => {
                    const url = String(item?.url || '');
                    if (!url) {
                        return;
                    }
                    const label = String(item?.label || 'Template image');
                    const $button = $(`
                        <button type="button" class="bb-template-image-library-item" title="${label.replace(/"/g, '&quot;')}">
                            <img src="${url}" alt="">
                        </button>
                    `);
                    $button.on('click', () => {
                        this.showTemplateImageLibraryPreview($modal, url, label);
                    });
                    $grid.append($button);
                });
            },
            error: () => {
                $library.addClass('d-none');
            },
        });
    },

    selectTemplateLibraryImage(url, $sourceModal){
        const pageId = $('#page_id').val();
        if (!pageId || !url) {
            return;
        }

        const $modal = ($sourceModal && $sourceModal.length) ? $sourceModal : $('#dropzone-modal');
        const isDropzoneModal = $modal.is('#dropzone-modal');
        // Drive the loading state off the Apply button the user actually clicked.
        // (The dropzone modal also contains a separate `button[data-save]` "Upload"
        // button, so scoping by the modal alone would animate the wrong button and
        // leave Apply with no feedback.) Scope to the current modal so the right
        // library instance is targeted.
        const modalId = $modal.attr('id');
        const modalSelector = modalId ? `#${modalId}` : '';
        const SaveBtn = new SaveButton(modalSelector, '.bb-template-image-library-preview-apply');

        if (!isDropzoneModal) {
            this.setupBackgroundImageLibraryContext($modal);
        }

        SaveBtn.startLoading('Applying');

        const data = new FormData();
        data.append('selected_url', url);
        if (HasAttachments.QueryData) {
            Object.keys(HasAttachments.QueryData).forEach((key) => {
                data.append(key, HasAttachments.QueryData[key]);
            });
        }

        $.ajax({
            url: this.config.selectImageUrl(pageId),
            method: 'POST',
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                SaveBtn.stopLoading(true, 'Apply').then(() => {
                    SaveBtn.showSuccess().then(() => setTimeout(() => {
                        try {
                            HasAttachments.SuccessCallback(response);
                        } catch (error) {
                            console.error('Error in SuccessCallback:', error);
                        }
                        if (isDropzoneModal) {
                            if (HasAttachments.dropzone && HasAttachments.dropzone.container) {
                                HasAttachments.dropzone.container.modal('hide');
                            } else {
                                $('#dropzone-modal').modal('hide');
                            }
                            if (HasAttachments.dropzone) {
                                delete HasAttachments.dropzone;
                            }
                        } else {
                            this.resetTemplateImageLibraryView($modal);
                        }
                    }, 700));
                });
            },
            error: (response) => {
                SaveBtn.stopLoading(false, 'Apply').then(() => {
                    SaveBtn.showError();
                });
                const message = response?.responseJSON?.message
                    || (response?.responseJSON?.errors ? Object.values(response.responseJSON.errors)[0]?.[0] : null)
                    || 'Could not apply selected image.';
                if (isDropzoneModal) {
                    $('.dropzone-error-message-container').text(message).removeClass('d-none');
                } else {
                    this.getTemplateImageLibraryRoot($modal)
                        .find('.bb-template-image-library-error')
                        .text(message)
                        .removeClass('d-none');
                }
            },
        });
    },
    initColorPicker(){
        $('#overlay_color').colorpicker({ format: 'hex' }).on('change', function (e) {
            let color = $(this).val();
            let preview = $('#overlay-preview')[0]
            preview.style.backgroundColor = color
        });
        $('#base_color').colorpicker({format: 'hex'});
        $('#description_text_color').colorpicker({format: 'hex'});
        $('#title_text_color').colorpicker({format: 'hex'});
        $('#label_text_color').colorpicker({format: 'hex'});
        $('#button_text_color').colorpicker({format: 'hex'});
        $('#button_background').colorpicker({format: 'hex'});
        $('#background_color').colorpicker({format: 'hex'});
        $('#company_name_text_color').colorpicker({format: 'hex'});
        $('#buttons_text_color').colorpicker({format: 'hex'});
        $('#button_border_color').colorpicker({format: 'hex'});
        $('.builder-colorpicker').each(function () {
            const $input = $(this);
            if ($input.data('colorpicker')) {
                $input.colorpicker('destroy');
            }
            $input.colorpicker({ format: 'hex' });
        });
    },

    initRoundSliders(){
        const listRoundSliders = []
        let sliderElems = $('#form-container')[0].getElementsByClassName('round-slider')
        for(const el of sliderElems){
            const slider = new RoundSlider(el)
            listRoundSliders.push(slider)
        }
        $('#form-container').find('.switch-component-settings').on('click', ()=>{
            setTimeout(()=>{
                for(let slider of listRoundSliders){
                    slider.updateDimensions()
                    slider.updateSlider(slider.value)
                }
            },200)
        })
    },

    moveElement() {
        if (
            window.__BB_WTM_SCREENSHOT_CAPTURE__ === true
            || document.documentElement.classList.contains('bb-wtm-screenshot-capture')
            || document.documentElement.dataset.bbWtmScreenshot === '1'
        ) {
            return;
        }

        // The header form stays inside the hero at all widths; only the snippet's
        // mobile mode (mm=1) toggles. Moving it below the header was a V1 bug.
        const headerForm = document.getElementById('header-form');
        const heroContainer = document.querySelector('.major-banner .page-container');
        if (headerForm && heroContainer) {
            if (!headerForm.parentNode.isEqualNode(heroContainer)) {
                heroContainer.appendChild(headerForm);
            }
            const $headerFormIframe = $(headerForm).find('iframe');
            const headerFormSrc = $headerFormIframe.attr('src');
            if (headerFormSrc) {
                const nextHeaderFormSrc = window.innerWidth < 1000
                    ? (headerFormSrc.includes('&mm=1') ? headerFormSrc : headerFormSrc + '&mm=1')
                    : headerFormSrc.replaceAll('&mm=1', '');
                if (nextHeaderFormSrc !== headerFormSrc) {
                    $headerFormIframe.attr('src', nextHeaderFormSrc);
                }
            }
        }

        const forms = [{
            elementToMove: document.getElementById('footer-form'),
            targetLocation: document.getElementById('primary'),
            container: document.querySelector('.site-footer__form'),
            chnageOrientation: false,
            mode: 'append',
        },{
            // Like #header-form, the horizontal form stays inside the hero on mobile.
            elementToMove: document.getElementById('header-form-horizontal'),
            targetLocation: heroContainer || document.getElementById('primary'),
            container: document.querySelector('#primary')?.querySelector('.horizontal-form-container'),
            chnageOrientation: true,
            mode: 'append',
        },{
            elementToMove: document.querySelector('.block-form'),
            targetLocation: document.querySelector('.container-mobile-form'),
            container: document.querySelector('#primary')?.querySelector('.full-container'),
            chnageOrientation: true,
            mode: 'append',
        }];
        forms.forEach((form) => {
            if (form.elementToMove && form.targetLocation && form.container) {

                if (window.innerWidth < 1000 && !form.elementToMove.parentNode.isEqualNode(form.targetLocation)) {
                    let src = $(form.elementToMove).find('iframe').attr('src');
                    if(form.chnageOrientation){
                        src = src.replaceAll('&or=2', '');
                    }
                    src = src+'&mm=1';
                    $(form.elementToMove).find('iframe').attr('src', src);
                    form.mode === 'append' ? form.targetLocation.appendChild(form.elementToMove) : form.targetLocation.prepend(form.elementToMove);

                    if (form.elementToMove.attributes.id.value == 'footer-form') {
                        form.elementToMove.querySelector('#contact-form-bizbaby').classList.remove('d-none');
                        form.elementToMove.querySelector('.show-form-button').classList.add('d-none');
                    }
                } else if (window.innerWidth >= 1000 && !form.elementToMove.parentNode.isEqualNode(form.container)) {
                    let src = $(form.elementToMove).find('iframe').attr('src');

                    if(src){
                        if(form.chnageOrientation){
                            src = src+'&or=2';
                        }
                        src = src.replaceAll('&mm=1', '');
                        $(form.elementToMove).find('iframe').attr('src', src);
                    }
                    form.container.appendChild(form.elementToMove);
                    if (form.elementToMove.attributes.id.value == 'footer-form') {
                        form.elementToMove.querySelector('#contact-form-bizbaby').classList.add('d-none');
                        form.elementToMove.querySelector('.show-form-button').classList.remove('d-none');
                    }
                }
            }
        });
    },
    handleResize(self) {
        clearTimeout(self.timeout);
        self.timeout = setTimeout(() => {
            self.moveElement();
            //self.updateFontSizes();
        }, 30);
    },
    initResizeActions(){
        let self = this;
        /* document.addEventListener('DOMContentLoaded', ()=>{
            console.log('DOMContentLoaded');

            self.moveElement(self)
        }); */
        $(document).ready(() => {
            self.moveElement(self)
        });
        // window.addEventListener('resize', self.handleResize(self));
        $(window).on('resize', ()=>{
            self.handleResize(self);
        });
        window.addEventListener('load', ()=>{
            self.moveElement(self)
        });

        // let iframe = document.querySelector('#job-request-bizbaby iframe');
        // iframe.addEventListener('load', function () {
        //     this.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        // });
    },
    loginModal(){
        $('.login-open').click((e)=>{
            const modal = document.getElementById('login-modal')
            modal.style.zIndex = '999999';
            modal.style.opacity = '1';
            modal.style.visibility = 'visible';
            $(modal).modal('show');

            window.addEventListener( 'click', ( event ) => {
				if ( event.target === modal ) {
					modal.style.zIndex = '-999999';
                    modal.style.opacity = '0';
                    modal.style.visibility = 'hidden';
                    $(modal).modal('hide');
				}
			} );
        });
    },
    mobileMenu(){
        $('body')
            .off('click.navCategoryToggle')
            .on('click.navCategoryToggle', '.nav-category-toggle', function(event) {
                event.preventDefault();
                const $item = $(this).closest('.nav-category-menu-item');
                $item.toggleClass('is-open');
                $item.siblings('.nav-category-menu-item').removeClass('is-open');
            });

        $(document)
            .off('click.navCategoryOutside')
            .on('click.navCategoryOutside', function(event) {
                if (!$(event.target).closest('.nav-category-menu-item').length) {
                    $('.nav-category-menu-item').removeClass('is-open');
                }
            });

        $('.menu-toggle').click(function() {
            const button = $(this)[0];
            const siteNavigation = $(this).parents('.main-navigation')[0];
            $(siteNavigation).toggleClass('toggled');
            if ( $(this).attr( 'aria-expanded' ) === 'true' ) {
				$(this).attr( 'aria-expanded', 'false' );
			} else {
				$(this).attr( 'aria-expanded', 'true' );
			}
            document.addEventListener(
                'click',
                function( event ) {
                    const isClickInside = siteNavigation.contains( event.target );

                    if ( ! isClickInside ) {
                        siteNavigation.classList.remove( 'toggled' );
                        button.setAttribute( 'aria-expanded', 'false' );
                    }
                }
            );
        });

    },

    galleryView(){
        $(document).ready(()=>{
            GalleryViewer.loadAllGalleryViewers()
        });
        $('body').off('click', '.mosaic-cont')
        .on('click', '.mosaic-cont', function(ev){
            const btn = $(ev.currentTarget)
            const img = btn.find('img')
            const findId = btn.attr('data-target-viewer')
            const viewer = GalleryViewer.VIEWERS.find(el=>el.viewer.id == findId)
            if(viewer){
                let imgSrc = img.attr('src')
                viewer.show(imgSrc)
            }
        })
    },

    updateFontWeidht(){
        $('body').off('change', '.component_font_family')
        .on('click', '.component_font_family', function() {
            const selectedOption = $(this).find('option:selected');
            const font_class = selectedOption[0].classList[0];
            this.classList.forEach((element,index) => {
                console.log(element,index);
                if (element.indexOf('ff-')>=0) {
                    $(this).removeClass(this.classList[index]);
                }
            });
            $(this).addClass(font_class);
        });
    },

    showFlyError(errors){
        $('.fly-errors-container').html('');

        // Accept our [{name, error_message}] shape, Laravel's
        // {field: [messages]} object, or nothing at all (5xx) — never throw.
        if (!errors) { alert('Save failed. Please try again.'); return; }
        if (!Array.isArray(errors)) {
            errors = Object.keys(errors).map(function (name) {
                var m = errors[name];
                return { name: name, error_message: Array.isArray(m) ? m[0] : String(m) };
            });
        }

        errors.forEach(element => {
            let parent = $(`#${element.name}`).parent();
            $(`#${element.name}`).css('border-color', 'red');
            $(parent).find('.fly-error-message').remove();
            //$('.fly-errors-container').append(
            $(parent).append(
                `<div class="fly-error-message ${element.name}">`+
                `${element.error_message}`+
                '<div>'
            );
            let posX = $(`#${element.name}`).position().left + 10;
            let posY = $(`#${element.name}`).position().top - $(parent).find('.fly-error-message').height() - 40;
            // console.log($(`#${element.name}`).offset(), $(`#${element.name}`).position());

            $(`.fly-error-message.${element.name}`).css({top:posY, left:posX});
            setTimeout(() => {
                $(`.fly-error-message.${element.name}`).hide();
            }, 5000);
        });
    },
    // Универсальный CSS-контрол: живой предпросмотр произвольных стилей.
    // Любой контрол с data-css-property применяет своё значение к элементам,
    // заданным data-css-target (CSS-селектор). Без таргета — no-op (безопасно).
    // Авторитетное применение всё равно происходит при сохранении (ре-рендер блока).
    cssLivePreviewActions(){
        $('body').off('input.csslive change.csslive', '[data-css-property]')
        .on('input.csslive change.csslive', '[data-css-property]', function() {
            const prop = $(this).data('css-property');
            const target = $(this).data('css-target');
            if (!prop || !target) {
                return;
            }
            const value = $(this).val();
            try {
                document.querySelectorAll(target).forEach((el) => {
                    el.style.setProperty(prop, value, 'important');
                });
            } catch (e) {
                // невалидный селектор/свойство — игнорируем (предпросмотр необязателен)
            }
        });
    },

    addNewBlockActions(){
        const $this = this;
        $('body').off('click','.add-block-btn')
        .on('click','.add-block-btn',function(e) {
            const container = $(this).parents('.add-block-section');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(container).find('.blocks-options').addClass('hidden');
                $(container).find('.select-block-btn').removeClass('selected');
                $(container).find('.images-block-options').addClass('hidden');
                $(container).find('.text-block-options').addClass('hidden');
                $(container).find('.video-block-options').addClass('hidden');
                $('.back-select-block').addClass('hidden');
            } else {
                $(this).addClass('active');
                $(container).find('.blocks-options').removeClass('hidden');
            }
        });
        $('body').off('click','.select-block-btn')
        .on('click','.select-block-btn',function(e) {
            let container = $(this).parents('.add-block-section');
            const section = $(this).data('section');
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(container).find('.back-select-block').addClass('hidden');
            } else {
                $(container).find('.select-block-btn').removeClass('selected');
                $(this).addClass('selected');
                $(container).find('.back-select-block').removeClass('hidden');
                $(container).find('.blocks-options').addClass('hidden');
                $(container).find(`.${section}-block-options`).removeClass('hidden');
            }
        });
        $('body').off('click','.back-select-block').on('click','.back-select-block',function() {
            let container = $(this).parents('.add-block-section');
            $(this).addClass('hidden');
            $(container).find('.blocks-options').removeClass('hidden');
            $(container).find('.images-block-options').addClass('hidden');
            $(container).find('.text-block-options').addClass('hidden');
            $(container).find('.video-block-options').addClass('hidden');
        });

        $('body').off('click','.block-option')
        .on('click', '.block-option', function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }
            const page_id = $('#page_id').val();
            const type = $(this).data('block_type');
            const position = $(this).data('position');
            const subtype = $(this).data('subtype') ?? null;
            const view = $(this).data('type_view') ?? null;
            const layout = $(this).data('layout-type') ?? null;
            const curr_elem = $(this);
            const container = curr_elem.parents('.positioned-block').length>0 ? curr_elem.parents('.positioned-block') : curr_elem.parents('.add-block-section');
            let data = {
                block_type: type,
                position: position,
                type_view: subtype,
                view: view,
                layout_type: layout
            };

            $.ajax({
                method: 'POST',
                url: `${$this.pageBaseUrl(page_id)}/blocks/create`,
                data: data,
                success: (response)=>{
                    $this.config.handleCreatedBlockResponse(response, container, $this);
                },
                error: (response) => {
                    console.log(response);
                }
            });

        });
    },

    modalActions(){
        $('body').off('click', '.switch-component-settings')
        .on('click', '.switch-component-settings', function() {
            $('.switch-component-settings').removeClass('active');
            $(this).addClass('active');
            const container = $(this).parents('.component-settings-container');
            const tab_name = $(this).data('tab_name');
            const settings_tab = $(container).find(`.${tab_name}-tab`);
            if (tab_name == 'images') {
                $(container).find('.images-actions').removeClass('d-none');
            }else{
                $(container).find('.images-actions').addClass('d-none');
            }
            if(tab_name == 'styling' || tab_name == 'styles'){
                $('.align-btns-container').removeClass('d-none').addClass('d-flex')
            }else{
                $('.align-btns-container').addClass('d-none').removeClass('d-flex')
            }
            $('.settings-tab').addClass('d-none');
            $(settings_tab).removeClass('d-none');
        })

        $('body').off('input', '.component-settings-container #video_url')
        .on('input', '.component-settings-container #video_url', function() {
            console.log($(this).val());
            const regexp = /^https:\/\/www.youtube.com\/\w+/;
            const regexp_short = /^https:\/\/youtu.be\/\w+/;
            if (regexp.test($(this).val())) {
                $(this).parents('form').find('.edit-component-btn').removeAttr('disabled');
            }else if(regexp_short.test($(this).val())){
                $(this).parents('form').find('.edit-component-btn').removeAttr('disabled');
            }else{
                $(this).parents('form').find('.edit-component-btn').attr('disabled', 'disabled');
            }
        })

        $('body').off('click', '.hide-elem-btn').on('click', '.hide-elem-btn', function() {
            const element = $(this).data('elem');
            const elem_id = $(this).data('id');
            if ($(`#${element}`).val() == 0) {
                $(`#${element}`).val(1);
                $(`#${element}`).parent().find('.hide-elem').removeClass('d-none');
                $(`#${element}`).parent().find('.show-elem').addClass('d-none');

                if (elem_id) {
                    $(`#${element}`).parents('form').find(`.hidable-elem-${elem_id}`).addClass('opacity-40');
                }
            }else{
                $(`#${element}`).val(0)
                $(`#${element}`).parent().find('.hide-elem').addClass('d-none');
                $(`#${element}`).parent().find('.show-elem').removeClass('d-none');

                if (elem_id) {
                    $(`#${element}`).parents('form').find(`.hidable-elem-${elem_id}`).removeClass('opacity-40');
                }
            }
        })

        $('body').off('.edit-background-image-btn').on('click','.edit-background-image-btn', (e)=> {
            const form = $(e.currentTarget).parents('form');
            const page_id = $('#page_id').val();
            const parent = $(e.currentTarget).parents('.modal').attr('id');
            const saveBtn = new SaveButton(`#${parent}`);
            const requestOptions = this.config.backgroundUpdateRequest(form);
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/update-background`,
                ...requestOptions,
                beforeSend: () => {
                    saveBtn.startLoading();
                },
                success: (response)=>{
                    if (response?.background_styles) {
                        this.applyDesignerBackgroundStyles(response.component_type || requestOptions.data?.component_type, response.background_styles);
                        this.showBuilderSidePanelStatus(true, 'Saved');
                    } else {
                        location.reload(true);
                    }
                    saveBtn.stopLoading(false,'Save');
                },
                error: (response) => {
                    console.log(response);
                    saveBtn.stopLoading(false,'Save');
                }
            });
        });
    },

    editMediaBlock(){
        $('body').on('click','.block-images-components .file-menu', (e) => {
            e.preventDefault();
            const container = $(e.currentTarget).parents('.component-image-container');
            container.find('.image-control-menu').removeClass('hided');
            container.find('.image-tab').addClass('hided');
        });
        $('body').on('click', '.block-images-components .close-menu', (e)=>{
            const container = $(e.currentTarget).parents('.component-image-container');
            container.find('.image-control-menu').addClass('hided');
            container.find('.image-tab').removeClass('hided');
        });

        $('body').on('click', '.upload-image-btn', (e)=>{
            const blockId = $(e.currentTarget).data('block_id') ?? null;
            const componentType = $(e.currentTarget).data('component_type') ?? null;
            const itemType = $(e.currentTarget).data('item_type');

            if ($(e.currentTarget).closest('.select_block_part_modal').length) {
                $('.select_block_part_modal').remove();
                this.showEditElementForm({
                    form_type: 'edit',
                    block_id: blockId,
                    item_type: itemType,
                    content_type: $(e.currentTarget).data('content_type'),
                });
                return;
            }

            if ((componentType === 'header_image' || componentType === 'footer_image') && ! blockId && ! itemType) {
                const $modal = $(e.currentTarget).closest('.modal');
                HasAttachments.QueryData = { component_type: componentType };
                HasAttachments.SuccessCallback = (r) => {
                    this.applyBackgroundImageSelectionResponse($modal, r, componentType);
                };
                return;
            }

            const data = {
                form_type: 'edit',
                block_id: $(e.currentTarget).data('block_id'),
                item_type: $(e.currentTarget).data('item_type'),
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);


            const container = $(e.currentTarget).parents('.modal-body').find('.block-images-components');

            const qData={}
            if(componentType)
                qData.component_type = componentType
            if(blockId)
                qData.block_id = blockId
            HasAttachments.QueryData = qData;
            HasAttachments.SuccessCallback = (r) => {
                console.log(r, container);
                $(container).html(r.view);
                if (r.images_count && r.images_count >=8) {
                    $(container).parent().find('.upload-image-btn').attr('disabled', true);
                    $(container).parent().find('.upload-image-btn').parent().prepend("<div style='font-size: 0.875rem; text-align: center; margin: 0.5rem 0;'>You've reached maximum number of pictures for this container</div>");
                }
            };
        })
        $('body').on('click', '.upload-video-part-btn', (e)=>{
            $('.select_block_part_modal').remove();
            const data = {
                form_type: 'edit',
                block_id: $(e.currentTarget).data('block_id'),
                item_type: $(e.currentTarget).data('item_type'),
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);
        })
    },

    checkPageSizeForFontSize(){

        // this.updateFontSizes();
        /* let elems = $('#page header').find('h2, h3').toArray();
        elems.forEach(element => {
            let font_size = $(element).css('font-size').replace('px','');
            font_size *= 0.7;
            $(element).css('font-size', font_size);
        }); */
    },

    updateFontSizes(){
        const elem_k = {
            header: {
                h2: '0.7',
                h3: '0.9'
            }
        }
        if (window.innerWidth>768) {

        } else {
            for (const key in elem_k) {
                if (Object.hasOwnProperty.call(elem_k, key)) {
                    const element_options = elem_k[key];
                    let container = $(key);
                    for (const key2 in element_options) {
                        if (Object.prototype.hasOwnProperty.call(element_options, key2)) {
                            let elem = $(container).find(key2);
                            let font_size = $(elem).css('font-size').replace('px','');
                            font_size *= element_options[key2];
                            $(elem).css('font-size', font_size);
                        }else{
                            console.log('неизвестная ошибка 1', );
                        }
                    }
                }else{
                    console.log('неизвестная ошибка 2');

                }
            }
        }
    },
    editReviewActions(){
        $('body').off('change','#review-platform-select')
        .on('change', '#review-platform-select', (e)=>{
            const value = $(e.currentTarget).val();
            if ($(e.currentTarget).val() == 'google') {
                $(e.currentTarget).parents('.form-row').find('img').attr('src', `/images/business_pages/${value}-platform-icon.png`).css({height:'', width: ''});
            }else{
                $(e.currentTarget).parents('.form-row').find('img').attr('src', `/images/business_pages/source-preview.png`).css({height:'auto', width: 'auto'});
            }
        })
        $('body').on('change', '#customer-image', (e)=>{
            const img = $(e.currentTarget).parents('.form-row').find('.customer-image-preview img');
            const file = e.currentTarget.files[0];
            const imgURL = URL.createObjectURL(file);
            console.log(file, imgURL);
            if (img.length>0) {
                img.attr('src', imgURL);
            } else {
                $(e.currentTarget).parents('.form-row').find('.customer-image-preview').html(`<img class="image-preview hidable-elem-customer-image" src="${imgURL}">`);
            }
            const btn = $(e.currentTarget).parents('.form-row').find('.hide-elem-btn')
            btn.removeAttr('disabled')
            const element = $(btn).data('elem');
            $(`#${element}`).val(0);
            $(`#${element}`).parent().find('.hide-elem').addClass('d-none');
            $(`#${element}`).parent().find('.show-elem').removeClass('d-none');
        });
        $('body').off('click', '.review-star')
        .on('click', '.review-star', (e)=>{
            const stars = $(e.currentTarget).data('number');
            $('.review-star').removeClass('selected');
            console.log($(e.currentTarget).prevAll('.review-star'));
            $(e.currentTarget).addClass('selected');
            $(e.currentTarget).prevAll('.review-star').addClass('selected');
            $('#stars').val(stars);
        });
        $('body').off('change', '#review_confirmation')
        .on('change', '#review_confirmation', (e)=>{
            if($(e.currentTarget).is(':checked')){
                $(e.currentTarget).parents('.form-row').find('button').removeAttr('disabled');
            }else{
                $(e.currentTarget).parents('.form-row').find('button').attr('disabled', true);
            }
        })
    },

    activateReviewSlider(){
        /*const slider = $('.reviews-navigation');
        const parent = slider.parent();
        let interval = false;
        if (slider.length > 0) {
            interval = setInterval(() => {
                const checked_slide = parent.find('input[type="radio"]:checked');
                if ($(checked_slide).next('input[type="radio"]').length > 0) {
                    $(checked_slide).next('input[type="radio"]').click();
                }else{
                    $(parent.find('input[type="radio"]')[0]).click();
                }

            }, 5000);
            console.log(interval);
        }
        $('body').off('click', '.reviews-navigation .review-step')
        .on('click', '.reviews-navigation .review-step', ()=>{

            if (interval) {
                for (let index = 0; index <= interval; index++) {
                    clearInterval(index);
                }
            }
            interval = setInterval(() => {
                const checked_slide = parent.find('input[type="radio"]:checked');
                if ($(checked_slide).next('input[type="radio"]').length > 0) {
                    $(checked_slide).next('input[type="radio"]').click();
                }else{
                    $(parent.find('input[type="radio"]')[0]).click();
                }
            }, 5000);
        });*/
    },

    reactiveTextEditing(){
        const resolveChangeKey = (visibleEl) => {
            return String(
                visibleEl.getAttribute('data-change-elem')
                ?? $(visibleEl).attr('data-change-elem')
                ?? $(visibleEl).data('changeElem')
                ?? ''
            ).trim();
        };

        const findReactiveTextarea = (visibleEl, changeKey) => {
            const classNames = changeKey.split(/\s+/).filter(Boolean);
            if (classNames.length === 0) {
                return null;
            }

            const matchesClass = (textarea) => {
                return classNames.every((className) => textarea.classList.contains(className));
            };

            let sibling = visibleEl.nextElementSibling;
            while (sibling) {
                if (sibling.matches('textarea.reactive-editing-component') && matchesClass(sibling)) {
                    return sibling;
                }
                sibling = sibling.nextElementSibling;
            }

            const scoped = visibleEl.parentElement?.querySelectorAll('textarea.reactive-editing-component') ?? [];
            for (const textarea of scoped) {
                if (matchesClass(textarea)) {
                    return textarea;
                }
            }

            return null;
        };

        const populateVisibleFromTextarea = (visibleEl, textareaEl) => {
            const val = textareaEl.value;

            if (visibleEl.classList.contains('ladder')) {
                visibleEl.innerHTML = '';
                if (val.length > 0) {
                    val.split('\n').forEach((line) => {
                        if (line === '') {
                            visibleEl.appendChild(document.createElement('br'));
                        } else {
                            const row = document.createElement('div');
                            row.textContent = line;
                            visibleEl.appendChild(row);
                        }
                    });
                }
            } else {
                visibleEl.textContent = val;
            }
        };

        const syncVisibleToTextarea = (visibleEl, textareaEl) => {
            if (visibleEl.classList.contains('ladder')) {
                const lines = [];
                visibleEl.childNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'DIV') {
                        lines.push(node.textContent);
                    } else if (node.nodeName === 'BR') {
                        lines.push('');
                    }
                });

                textareaEl.value = lines.length > 0
                    ? lines.join('\n')
                    : visibleEl.innerText.replace(/\r\n/g, '\n');
            } else {
                textareaEl.value = visibleEl.textContent;
            }
        };

        const mountContentEditable = (visibleEl) => {
            visibleEl.dataset.reactiveEditing = '1';
            visibleEl.contentEditable = 'true';
            visibleEl.style.outline = 'none';
            visibleEl.style.cursor = 'text';
        };

        const unmountContentEditable = (visibleEl) => {
            visibleEl.contentEditable = 'false';
            visibleEl.style.outline = '';
            visibleEl.style.cursor = '';
            delete visibleEl.dataset.reactiveEditing;
        };

        const focusContentEditable = (visibleEl) => {
            visibleEl.focus();

            const range = document.createRange();
            range.selectNodeContents(visibleEl);
            range.collapse(false);
            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
        };

        $('body').off('click.reactiveText', '.editable-text').on('click.reactiveText', '.editable-text', (e) => {
            const visibleEl = e.currentTarget;
            if (visibleEl.dataset.reactiveEditing === '1') {
                return;
            }

            const changeKey = resolveChangeKey(visibleEl);
            if (changeKey === '') {
                return;
            }

            const textareaEl = findReactiveTextarea(visibleEl, changeKey);
            if (! textareaEl || textareaEl.dataset.reactiveEditing === '1') {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            const curr_elem = $(visibleEl);
            const editable_elem = $(textareaEl);

            populateVisibleFromTextarea(visibleEl, textareaEl);
            mountContentEditable(visibleEl);
            focusContentEditable(visibleEl);

            $(visibleEl).off('keydown.reactiveText').on('keydown.reactiveText', (ev) => {
                if (ev.key === 'Enter' && ! visibleEl.classList.contains('ladder')) {
                    ev.preventDefault();
                    visibleEl.blur();
                }
            });

            $(visibleEl).off('input.reactiveText').on('input.reactiveText', () => {
                syncVisibleToTextarea(visibleEl, textareaEl);
            });

            $(visibleEl).off('blur.reactiveText').on('blur.reactiveText', () => {
                syncVisibleToTextarea(visibleEl, textareaEl);
                editable_elem.attr('readonly', true);
                this.sendAndUpdatedReactiveElement({content:editable_elem.val()}, editable_elem.data('component_id'),editable_elem.data('part'),editable_elem.data('block_id'), (r)=>{
                    unmountContentEditable(visibleEl);
                    if (r) {
                        editable_elem.removeAttr('readonly');
                        if (curr_elem.hasClass('ladder')) {
                            curr_elem.text('');
                            if (editable_elem.val().length>0) {
                                editable_elem.val().split('\n').forEach(element => {
                                    if (element === '') {
                                        curr_elem.append('</br>');
                                    } else {
                                        curr_elem.append('<div>'+element+'</div>');
                                    }
                                });
                            }else{
                                curr_elem.append('Description Text');
                            }
                        } else {
                            curr_elem.text(editable_elem.val());
                        }
                    }
                }, () => {
                    unmountContentEditable(visibleEl);
                    populateVisibleFromTextarea(visibleEl, textareaEl);
                    editable_elem.removeAttr('readonly');
                });
            });
        });
    },

    sendAndUpdatedReactiveElement(REData, REId, REPart, block_id, successCallback=()=>{}, errorCallback=()=>{} ){
        const page_id = $('#page_id').val();
        $.ajax({
            method: 'POST',
            url: `${this.pageBaseUrl(page_id)}/component/${REId}/${REPart}`,
            data: REData,
            success: (r)=>{
                if (r.view) {
                    $(`.block-${block_id}`).html(r.view);
                    successCallback(false);
                }else{
                    successCallback(true);
                    // location.reload(true);
                }
            },
            error: (r)=>{
                errorCallback(r);
            }
        });
    },

    initAnchorBehavior(){
        $('body').off('click', 'a.smooth').on('click', 'a.smooth',(e)=>{
            e.preventDefault();
            const elem_id = $(e.currentTarget).attr('href');

            $(elem_id)[0].scrollIntoView({
                behavior: "smooth",
                block:    "start"
            });
        })
    },

    reactiveEditImage(){
        $('body').on('click', '.editable-image', (e)=>{

            HasAttachments.QueryData = {
                block_id: $(e.currentTarget).data('block_id'),
                component_id: $(e.currentTarget).data('component_id') ?? ''
            };
            HasAttachments.SuccessCallback = (r) => {
                location.reload(true);
            };
        })

        $('body').off('click', '.regenerate-ai-background-image-btn').on('click', '.regenerate-ai-background-image-btn', (e) => {
            const button = $(e.currentTarget);
            const modal = button.closest('.modal');
            const componentType = button.data('component_type') || modal.find('input[name="component_type"]').val();
            const promptValue = button.attr('data-ai-prompt') || '';
            const sourceModalSelector = button.data('source-modal') || '#edit-background-image-modal';
            this.closeBuilderSidePanel();
            this.showEditElementForm({
                form_type: 'regenerate_block',
                page_id: $('#page_id').val(),
                lock_scope: true,
                scope_default: 'images',
                modal_title: componentType === 'footer_image' ? 'Regenerate Footer Image With AI' : 'Regenerate Hero Image With AI',
                background_regeneration: true,
                component_type: componentType,
                source_modal: sourceModalSelector,
                prompt_value: promptValue,
            }, (response) => {
                const aiModal = this.openBuilderSidePanel(response, { expanded: true });
                aiModal.data('reopen-source-modal', sourceModalSelector);
            });
        });

        $('body').off('click', '.regenerate-ai-logo-btn').on('click', '.regenerate-ai-logo-btn', (e) => {
            const button = $(e.currentTarget);
            const modal = button.closest('.modal');
            const componentType = button.data('component_type') || 'nav_logo';
            const promptValue = button.attr('data-ai-prompt') || '';
            const sourceModalSelector = button.data('source-modal') || '#edit-main-header-modal';
            this.closeBuilderSidePanel();
            this.showEditElementForm({
                form_type: 'regenerate_block',
                page_id: $('#page_id').val(),
                lock_scope: true,
                scope_default: 'images',
                modal_title: 'Regenerate Logo With AI',
                background_regeneration: true,
                component_type: componentType,
                source_modal: sourceModalSelector,
                prompt_value: promptValue,
            }, (response) => {
                const aiModal = this.openBuilderSidePanel(response, { expanded: true });
                aiModal.data('reopen-source-modal', sourceModalSelector);
            });
        });
    },
    globalActions(){
        $('body').off('click', '.show-form-button button').on('click', '.show-form-button button', (e)=>{
            $(e.currentTarget).parents('#footer-form').find('#contact-form-bizbaby').removeClass('d-none');
            $(e.currentTarget).parent().addClass('d-none');
        });
    },

    initGlobalStyling(){
        
        if(!$('#global-styling-container').length) return

        $('#label-color').colorpicker({format: 'hex'});
        $('#header-color').colorpicker({format: 'hex'});
        $('#header-component-color').colorpicker({format: 'hex'});
        $('#description-color').colorpicker({format: 'hex'});
        $('#button-color').colorpicker({format: 'hex'});
        $('#blocks-background-color').colorpicker({format: 'hex'});
        $('#blocks-shadow-color').colorpicker({format: 'hex'});
        $('#button-background-color').colorpicker({format: 'hex'});
        $('#button-border-color').colorpicker({format: 'hex'});

        let changedInputNames = []

        $('#global-styling-container .color-container input').off('colorpickerChange.globalStyling')
        .on('colorpickerChange.globalStyling', (ev) => {
            const color = ev.color?.toString?.() ?? $(ev.currentTarget).val();
            if (color) {
                $(ev.currentTarget).val(color);
                $(ev.currentTarget).siblings('.color-preview').css('background-color', color);
            }
            ev.currentTarget.classList.add('is-edit');
            const name = ev.currentTarget.getAttribute('name');
            if (name && !changedInputNames.includes(name)) {
                changedInputNames.push(name);
            }
            $('#set-global-design-btn').attr('disabled', false);
        });

        $('#global-styling-container input, #global-styling-container select').off('input change').on('input change', (ev)=>{
            ev.currentTarget.classList.add('is-edit');
            let name = ev.currentTarget.getAttribute('name')
            if(!changedInputNames.includes(name))
                changedInputNames.push(name)
            $('#set-global-design-btn').attr('disabled', false);
        })

        const listRoundSliders = []
        let sliderElems = $('#global-styling-container')[0].getElementsByClassName('round-slider')
        for(const el of sliderElems){
            listRoundSliders.push(new RoundSlider(el))
        }

        for(let switcher of SimpleSectionSwitcher.LIST_SWITCHERS){
            switcher.switcherEl.addEventListener('afterswitch', ()=>{
                for(let slider of listRoundSliders){
                    slider.updateDimensions()
                    slider.updateSlider(slider.value)
                }
            })
        }

        $('body').off('click', '.global-styling-toggle-btn')
        .on('click', '.global-styling-toggle-btn', (e)=>{
            if($('#global-styling-container').hasClass('d-none')){
                $('#global-styling-container').removeClass('d-none')
                setTimeout(()=>{
                    for(let slider of listRoundSliders){
                        slider.updateDimensions()
                        slider.updateSlider(slider.value)
                    }
                },100)
            }else
                $('#global-styling-container').addClass('d-none')
        })

        $('body').off('click', '#set-global-design-btn')
        .on('click','#set-global-design-btn', (e)=>{
            if (this.config.useGlobalDesignConfirmation) {
                const data = {
                    form_type: 'confirm-global',
                    method:'set'
                };
                this.showEditElementForm(data);
                return;
            }
            this.submitGlobalDesignChanges('set', 'local', e.currentTarget, changedInputNames);
        });

        $('body').off('click', '#reset-global-design-btn')
        .on('click', '#reset-global-design-btn', (e)=>{
            if (this.config.useGlobalDesignConfirmation) {
                const data = {
                    form_type: 'confirm-global',
                    method:'reset'
                };
                this.showEditElementForm(data);
                return;
            }
            this.submitGlobalDesignChanges('reset', 'local', e.currentTarget, changedInputNames);
        })

        $('body').off('click', '.set-global-design')
        .on('click', '.set-global-design', (e)=>{
            const method = $(e.currentTarget).attr('data-method')
            const type = $(e.currentTarget).attr('data-type')
            this.submitGlobalDesignChanges(method, type, e.currentTarget, changedInputNames);
        })
    },

    submitGlobalDesignChanges(method, type = 'local', triggerEl = null, changedInputNames = []){
        if(method == 'set' && !changedInputNames.length) return

        const formData = new FormData();
        formData.append('save_type', type)
        formData.append('page_id', $('#page_id').val())

        if(method == 'set') {
            changedInputNames.forEach((name) => {
                formData.append('changed_input_names[]', name)
            })

            $('#global-design-form').find('[name]').each((_, field) => {
                const name = field.getAttribute('name')
                if (!name) {
                    return
                }
                const value = $(field).val()
                formData.append(name, value)
            })
        }

        const url = method == 'set'
            ? this.config.setGlobalSettingsUrl(this.getPageId())
            : this.config.resetGlobalSettingsUrl(this.getPageId())

        const isConfirmButton = $(triggerEl).hasClass('set-global-design')
        const saveButtonSelector = isConfirmButton
            ? `.set-global-design[data-type="${type}"]`
            : `#${method == 'set' ? 'set' : 'reset'}-global-design-btn`
        const SaveBtn = new SaveButton(null, saveButtonSelector)
        const btnTxt = $(triggerEl).text()

        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: () => {
                SaveBtn.startLoading();
                if (isConfirmButton) {
                    $(triggerEl).closest('div').find(`.set-global-design:not([data-type="${type}"])`).attr('disabled', true)
                } else {
                    $('#set-global-design-btn').attr('disabled', true)
                }
                $('#reset-global-design-btn').attr('disabled', true)
            },
            success: (response) => {
                this.replaceEditorResponseFragments(response);
                SaveBtn.stopLoading(true, btnTxt).then(() => {
                    $('#set-global-design-btn').removeAttr('disabled')
                    $('#reset-global-design-btn').removeAttr('disabled')
                    if (isConfirmButton) {
                        $(triggerEl).closest('div').find(`.set-global-design`).attr('disabled', true)
                    }
                    SaveBtn.showSuccess()
                        .then(() => {})
                })
            },
            error: () => {
                SaveBtn.stopLoading(false, btnTxt).then(() => {
                    $('#set-global-design-btn').removeAttr('disabled')
                    $('#reset-global-design-btn').removeAttr('disabled')
                    $(`.set-global-design`).removeAttr('disabled')
                    SaveBtn.showError().then()
                });
            }
        });
    },

    embededFormActions(){
        const $scope = this.getEmbededFormScope();
        $scope.find('#emb_service').off('change').on('change', (e)=>{
            const service = $(e.currentTarget).val()
            $.ajax({
                method: 'POST',
                url: this.config.serviceTimeUrl(this.getPageId()),
                data: {
                    service: service,
                },
                success: (response) => {
                    if (response.dates) {
                        let count = 0;
                        $scope.find('#emb_date').html('');
                        $scope.find('#emb_time').html('');
                        response.dates.forEach(element => {
                            $scope.find('#emb_date').append(`<option value="${element.id}">${element.title}</option>`)
                            element.times.forEach(time => {
                                $scope.find('#emb_time').append(`<option ${count !== 0 ? 'class="d-none"' : ''} value="${time.value}" data-for-date="${element.id}">${time.text}</option>`)
                            });
                            count ++;
                        });
                    }
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
        $scope.find('#emb_date').off('change')
        .on('change',(e)=>{
            const form = $(e.currentTarget).parents('.embeded-form');
            const date = $(e.currentTarget).val();
            const times_select = form.find('#emb_time');
            times_select.find('option').addClass('d-none');
            times_select.find(`option[data-for-date="${date}"]`).removeClass('d-none');
            times_select.find(`option[data-for-date="${date}"]`)[0].setAttribute('selected');
        });
        $scope.find('#emb_form_btn').off('click').on('click',(e)=>{
            const form = $(e.currentTarget).parents('.embeded-form');
            const link =  $(e.currentTarget).data('route');
            const service = form.find('#emb_service').val();
            const date = form.find('#emb_date').val();
            const time = form.find('#emb_time').val();
            let d = new Date();
            d.setTime(d.getTime() + (1 * 6 * 60 * 60 * 1000));
            document.cookie = `emb_service=${service};expires=${d.toUTCString()};path=/; SameSite=Strict;`;
            document.cookie = `emb_date=${date};expires=${d.toUTCString()};path=/; SameSite=Strict;`;
            document.cookie = `emb_time=${time};expires=${d.toUTCString()};path=/; SameSite=Strict;`;
            window.open(link,'_blank');
        });
        $scope.find('.embeded-form-field-label').off('click').on('click',(e)=>{
            e.preventDefault();
            let targetName = $(e.currentTarget).attr('for');
            if (!targetName) {
                return;
            }
            const escapedId = typeof $.escapeSelector === 'function' ? $.escapeSelector(targetName) : String(targetName);
            const $target = $scope.find(`#${escapedId}`);
            if ($target.length) {
                $target.trigger('focus');
                $target.trigger('click');
                if ($target[0]) {
                    $target[0].dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                }
            }
        });
    },

    initAiBlockRegenerationResume(){
        const isWtmDesign = location.pathname.includes('/admin/website-template-manager/page/')
            && location.pathname.includes('/design');
        if (!isWtmDesign) {
            return;
        }
        const pageId = this.getPageId();
        if (!pageId) {
            return;
        }
        $('.positioned-block[data-ai-regenerating="1"]').each((_, el) => {
            const blockId = $(el).data('id');
            if (blockId) {
                this.startAiRegenerationPoll(pageId, blockId);
            }
        });
    },

    initDesignerAssetRegenerationResume(){
        if (!isWtmPageDesignRoute()) {
            return;
        }
        const pageId = this.getPageId();
        if (!pageId) {
            return;
        }

        $.ajax({
            method: 'GET',
            url: `${this.pageBaseUrl(pageId)}/regenerate-asset-ai-status`,
            success: (response) => {
                const assetType = String(response?.asset || '');
                if (response?.status !== 'pending' || assetType === '') {
                    return;
                }
                this.markBackgroundAiRegenerating(assetType);
                this.startDesignerAssetRegenerationPoll(pageId, assetType, {});
            },
        });
    },

    markBlockAiRegenerating(blockId){
        const $b = $(`.positioned-block[data-id="${blockId}"]`);
        if (!$b.length) {
            return;
        }
        $b.addClass('is-ai-regenerating').attr('data-ai-regenerating', '1');
        const $section = $b.children('section.page-section').first();
        if ($section.length && !$section.find('.ai-block-regeneration-overlay').length) {
            $section.prepend(
                '<div class="ai-block-regeneration-overlay" aria-live="polite">'
                + '<div class="ai-block-regeneration-spinner" role="status"></div>'
                + '<span>Regenerating with AI…</span></div>'
            );
        }
    },

    clearAiRegenerationUi(blockId){
        const $b = $(`.positioned-block[data-id="${blockId}"]`);
        $b.removeClass('is-ai-regenerating').attr('data-ai-regenerating', '0');
        $b.find('.ai-block-regeneration-overlay').remove();
    },

    backgroundAiTarget(componentType){
        if (componentType === 'header_image') {
            return $('section.major-banner').first();
        }
        if (componentType === 'footer_image') {
            return $('.site-footer').first();
        }
        if (componentType === 'nav_logo') {
            return $('#site-navigation .site-branding').first();
        }

        return $();
    },

    markBackgroundAiRegenerating(componentType){
        const $target = this.backgroundAiTarget(componentType);
        if (!$target.length) {
            return;
        }
        if ($target.css('position') === 'static') {
            $target.css('position', 'relative');
        }
        if (!$target.find('.ai-block-regeneration-overlay').length) {
            $target.prepend(this.buildAiRegenerationOverlayHtml(componentType === 'nav_logo' ? 'logo' : 'default'));
        }
    },

    buildAiRegenerationOverlayHtml(variant = 'default'){
        if (variant === 'logo') {
            return '<div class="ai-block-regeneration-overlay ai-block-regeneration-overlay--logo" aria-live="polite" aria-busy="true">'
                + '<div class="ai-block-regeneration-spinner" role="status" aria-label="Regenerating logo"></div></div>';
        }

        return '<div class="ai-block-regeneration-overlay" aria-live="polite">'
            + '<div class="ai-block-regeneration-spinner" role="status"></div>'
            + '<span>Regenerating with AI…</span></div>';
    },

    clearBackgroundAiRegenerationUi(componentType){
        const $target = this.backgroundAiTarget(componentType);
        if (!$target.length) {
            return;
        }
        $target.find('.ai-block-regeneration-overlay').remove();
    },

    cacheBustAssetUrl(url){
        const raw = String(url || '').trim();
        if (raw === '') {
            return '';
        }
        const separator = raw.includes('?') ? '&' : '?';
        return `${raw}${separator}_=${Date.now()}`;
    },

    resolveDesignerSourceModal(context = {}){
        const selector = String(context.sourceModalSelector || '').trim();
        if (selector) {
            const $fresh = $(selector);
            if ($fresh.length) {
                return $fresh;
            }
        }

        const sourceModal = context.sourceModal || $();
        return sourceModal.length ? sourceModal : $();
    },

    applyDesignerAssetRegenerationResult(assetType, response, context = {}) {
        const sourceModal = this.resolveDesignerSourceModal(context);
        const feedback = context.feedback || '';

        if (assetType === 'nav_logo') {
            const logoUrl = this.cacheBustAssetUrl(response?.path);
            if (sourceModal.length && logoUrl) {
                sourceModal.find('.preview-image.hidable-elem-component_logo').attr('src', logoUrl);
                if (response?.filename) {
                    sourceModal.find('.file-label').text(response.filename);
                }
                sourceModal.find('.regenerate-ai-logo-btn').attr('data-ai-prompt', response?.prompt ?? feedback ?? '');
            }
            if (logoUrl) {
                $('#site-navigation .site-branding img').first().attr('src', logoUrl);
            }
            return;
        }

        if (sourceModal.length && response?.view) {
            sourceModal.find('.background-image-preview-shell').html(response.view);
        }
        if (sourceModal.length) {
            sourceModal.find('.regenerate-ai-background-image-btn').attr('data-ai-prompt', response?.prompt ?? feedback ?? '');
        }
        if (response?.background_styles) {
            this.applyDesignerBackgroundStyles(assetType, response.background_styles);
        } else if (response?.path) {
            const imageUrl = this.cacheBustAssetUrl(response.path);
            if (assetType === 'header_image') {
                $('.edit-design-elemnt-btn.icon.header-image').parent().find('section.major-banner').first()
                    .css('background-image', `url(${imageUrl})`);
            } else if (assetType === 'footer_image') {
                $('.site-footer').first().css('background-image', `url(${imageUrl})`);
            }
        }
    },

    startDesignerAssetRegenerationPoll(pageId, assetType, context = {}) {
        const editor = this;
        const key = String(assetType || '');
        if (!key || editor.aiAssetRegenerationPollTimers[key]) {
            return;
        }

        const finish = () => {
            if (editor.aiAssetRegenerationPollTimers[key]) {
                clearInterval(editor.aiAssetRegenerationPollTimers[key]);
                delete editor.aiAssetRegenerationPollTimers[key];
            }
            editor.clearBackgroundAiRegenerationUi(assetType);
        };

        const poll = () => {
            $.ajax({
                method: 'GET',
                url: `${editor.pageBaseUrl(pageId)}/regenerate-asset-ai-status`,
                success: (response) => {
                    if (response?.status === 'pending') {
                        return;
                    }
                    finish();
                    if (response?.status === 'failed') {
                        alert(response.error || 'Unable to regenerate this image right now.');
                        return;
                    }
                    if (response?.status === 'idle') {
                        editor.applyDesignerAssetRegenerationResult(assetType, response, context);
                    }
                },
                error: () => {
                    // Keep polling — transient network errors should not stop regeneration UX.
                },
            });
        };

        poll();
        editor.aiAssetRegenerationPollTimers[key] = setInterval(poll, 2500);
    },

    startAiRegenerationPoll(pageId, blockId){
        const editor = this;
        const key = String(blockId);
        if (editor.aiRegenerationPollTimers[key]) {
            return;
        }
        const poll = () => {
            $.ajax({
                method: 'GET',
                url: `${editor.pageBaseUrl(pageId)}/blocks/${blockId}/regenerate-ai-status`,
                success: (response) => {
                    if (response.status === 'pending') {
                        return;
                    }
                    if (editor.aiRegenerationPollTimers[key]) {
                        clearInterval(editor.aiRegenerationPollTimers[key]);
                        delete editor.aiRegenerationPollTimers[key];
                    }
                    if (response.status === 'failed') {
                        editor.clearAiRegenerationUi(blockId);
                        alert(response.error || 'Unable to regenerate this block right now.');
                        return;
                    }
                    if (response.status === 'idle' && response.view) {
                        $(`.positioned-block[data-id="${blockId}"]`).replaceWith(response.view);
                        const inserted = $(`.positioned-block[data-id="${blockId}"]`)[0];
                        if (inserted) {
                            editor.initPaddingRanges(inserted);
                        }
                    }
                },
            });
        };
        poll();
        editor.aiRegenerationPollTimers[key] = setInterval(poll, 2500);
    },

    initPaddingRanges(container){
        const baseEl = container instanceof HTMLElement ? container : document
        const ranges = baseEl.getElementsByClassName('bb-range');
        const callback = (bbRange) => {
            let data = new FormData();
            const block_id = $(bbRange.input).data('block-id');
            data.append('id', block_id)
            data.append(bbRange.input.name, bbRange.value)
            const page_id = $('#page_id').val();
            $.ajax({
                method: 'POST',
                url: `${this.pageBaseUrl(page_id)}/blocks/update`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response) => { },
                error: (response) => {
                    console.log(response);
                }
            });
        }
        for(const range of ranges){
            const bbNewRange = new BBRange(range, 5000, callback)
            $(range).parent('.padding-range').find('.close-range-btn').on('click', ()=>{
                bbNewRange.stopCallback()
                callback(bbNewRange)
            })
        }
        $('body').off('click', '.padding-edit-btn')
        .on('click', '.padding-edit-btn', (ev)=>{
            $(ev.currentTarget).addClass('d-none')
            $(ev.currentTarget).parent('.padding-range').find('.bb-range').removeClass('d-none')
            $(ev.currentTarget).parent('.padding-range').find('.close-range-btn').removeClass('d-none')
        })
        $('body').off('click', '.close-range-btn')
        .on('click', '.close-range-btn', (ev)=>{
            $(ev.currentTarget).addClass('d-none')
            $(ev.currentTarget).parent('.padding-range').find('.bb-range').addClass('d-none')
            $(ev.currentTarget).parent('.padding-range').find('.padding-edit-btn').removeClass('d-none')
        })
        $('body').off('input', '.padding-range .range-input')
        .on('input', '.padding-range .range-input', (ev)=>{
            $($(ev.currentTarget).parents('.padding-range')[0]).find('.padding-edit-btn span').text(`padding ${ev.currentTarget.value}px`)
        })
    },

    initModalRanges(){
        let modal = $('#form-container').find('.modal')

        const overlayCallback = (bbRange) =>{
            let preview = modal.find('#overlay-preview')[0]
            preview.style.opacity = bbRange.value/100
        }

        if(modal.length){
            const ranges = modal[0].getElementsByClassName('bb-range');
            for (const range of ranges) {
                if(range.id == 'overlay_opacity')
                    new BBRange(range,0,overlayCallback,(value)=>`${value} %`)
                else
                    new BBRange(range)
            }
        }
    }
});

const business_page = createPageDesignEditor();

export { createPageDesignEditor };
export default business_page;
